export default function SVG({ name, classname = "", style = {} }) {
  if (name === "eye") {
    return (
      <svg
        className={classname}
        width="16"
        height="13"
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0.75C11.0081 0.75 13.0906 2.57042 14.3828 4.27539C14.7358 4.74119 14.9302 5.00414 15.0576 5.29688C15.1744 5.56538 15.25 5.90141 15.25 6.5C15.25 7.09859 15.1744 7.43461 15.0576 7.70312C14.9303 7.99587 14.7358 8.25882 14.3828 8.72461C13.0906 10.4295 11.0081 12.25 8 12.25C4.99186 12.25 2.90936 10.4295 1.61719 8.72461C1.26417 8.25882 1.06974 7.99586 0.942383 7.70312C0.825586 7.43461 0.75 7.0986 0.75 6.5C0.75 5.9014 0.825588 5.56538 0.942383 5.29688C1.06975 5.00415 1.26417 4.74119 1.61719 4.27539C2.90935 2.57043 4.99186 0.75 8 0.75Z"
          strokeOpacity="0.5"
          stroke-width="1.5"
        />
        <path
          d="M8.00037 4.8125C8.90058 4.81272 9.64978 5.55711 9.64978 6.5C9.64978 7.44289 8.90058 8.18728 8.00037 8.1875C7.09998 8.1875 6.34998 7.44302 6.34998 6.5C6.34998 5.55698 7.09998 4.8125 8.00037 4.8125Z"
          stroke-width="1.5"
        />
      </svg>
    );
  }
  if (name === "eyeClosed") {
    return (
      <svg
        className={classname}
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.55811 5.76753C8.55811 5.4593 8.30822 5.2094 7.99999 5.2094C7.69175 5.2094 7.44186 5.4593 7.44186 5.76753H8.55811ZM11.1373 4.96353C10.9692 4.70515 10.6234 4.632 10.365 4.80011C10.1067 4.96822 10.0335 5.31396 10.2017 5.57234L11.1373 4.96353ZM5.79831 5.57234C5.96643 5.31396 5.89326 4.96822 5.63489 4.80011C5.37653 4.632 5.0308 4.70515 4.86268 4.96353L5.79831 5.57234ZM3.81131 6.57935C3.64319 6.83773 3.71636 7.18347 3.97473 7.35158C4.2331 7.51969 4.57883 7.44653 4.74694 7.18816L3.81131 6.57935ZM13.6038 3.23623C13.3859 3.01826 13.0325 3.01826 12.8146 3.23623C12.5966 3.4542 12.5966 3.80753 12.8146 4.0255L13.6038 3.23623ZM13.9308 5.14176C14.1488 5.35973 14.5021 5.35973 14.7201 5.14176C14.9381 4.92379 14.9381 4.57046 14.7201 4.35249L13.9308 5.14176ZM7.44186 7.62796C7.44186 7.9362 7.69175 8.18609 7.99999 8.18609C8.30822 8.18609 8.55811 7.9362 8.55811 7.62796H7.44186ZM11.2531 7.18816C11.4212 7.44653 11.7669 7.51969 12.0252 7.35158C12.2836 7.18347 12.3567 6.83773 12.1886 6.57935L11.2531 7.18816ZM3.18544 4.0255C3.4034 3.80753 3.4034 3.4542 3.18544 3.23623C2.96748 3.01826 2.61408 3.01826 2.39612 3.23623L3.18544 4.0255ZM1.27986 4.35249C1.0619 4.57046 1.0619 4.92379 1.27986 5.14176C1.49783 5.35973 1.85122 5.35973 2.06918 5.14176L1.27986 4.35249ZM4.86268 4.96353L3.81131 6.57935L4.74694 7.18816L5.79831 5.57234L4.86268 4.96353ZM12.8146 4.0255L13.9308 5.14176L14.7201 4.35249L13.6038 3.23623L12.8146 4.0255ZM7.44186 5.76753V7.62796H8.55811V5.76753H7.44186ZM10.2017 5.57234L11.2531 7.18816L12.1886 6.57935L11.1373 4.96353L10.2017 5.57234ZM2.39612 3.23623L1.27986 4.35249L2.06918 5.14176L3.18544 4.0255L2.39612 3.23623Z"
          fillOpacity="0.5"
        />
        <path d="M1.07128 0.338416C0.94985 0.0550944 0.621737 -0.0761552 0.338416 0.0452713C0.0550945 0.166698 -0.0761553 0.494811 0.0452713 0.778132L1.07128 0.338416ZM15.9548 0.778132C16.0761 0.494811 15.9449 0.166698 15.6615 0.0452713C15.3782 -0.0761552 15.0501 0.0550944 14.9287 0.338416L15.9548 0.778132ZM8 5.20935C5.60087 5.20935 3.87827 4.01466 2.73468 2.7831C2.16304 2.16749 1.74393 1.55014 1.46809 1.08674C1.33049 0.855571 1.22942 0.664185 1.16358 0.532503C1.13068 0.466711 1.10665 0.415951 1.0913 0.382731C1.08364 0.366129 1.07815 0.353924 1.07481 0.346431C1.07314 0.342687 1.07186 0.339763 1.07128 0.338416C1.07126 0.338386 1.0713 0.338475 1.07128 0.338416C1.07135 0.338587 1.07128 0.338416 0.558274 0.558274C0.0452713 0.778132 0.0451597 0.777879 0.0452713 0.778132C0.045316 0.778244 0.0456434 0.778995 0.0457402 0.779219C0.0459262 0.779658 0.0461569 0.780186 0.0464174 0.780781C0.0469309 0.781987 0.0475931 0.783505 0.0483894 0.785336C0.0499894 0.78899 0.0521475 0.793894 0.0548637 0.800004C0.0602962 0.812223 0.067976 0.829264 0.0779331 0.850815C0.0978322 0.893911 0.126848 0.955067 0.165172 1.03171C0.24177 1.18491 0.355814 1.40049 0.508906 1.65768C0.814455 2.17101 1.27904 2.85598 1.91669 3.54263C3.19165 4.9157 5.18992 6.32561 8 6.32561V5.20935ZM10.4651 4.74856C9.74292 5.03283 8.92404 5.20935 8 5.20935V6.32561C9.07027 6.32561 10.0276 6.12037 10.8739 5.78727L10.4651 4.74856ZM15.4417 0.558274C14.9287 0.338416 14.9286 0.33852 14.9287 0.338416C14.9288 0.338297 14.9291 0.337619 14.9291 0.337701C14.929 0.33785 14.9288 0.338386 14.9283 0.339309C14.9275 0.341147 14.926 0.344511 14.9239 0.34934C14.9195 0.359007 14.9125 0.37453 14.9028 0.395486C14.8832 0.437398 14.8528 0.500936 14.8111 0.582586C14.7278 0.746006 14.6001 0.981195 14.4262 1.26018C14.0776 1.81977 13.5488 2.54668 12.8272 3.2239L13.5912 4.0378C14.4016 3.27711 14.989 2.46772 15.3736 1.8505C15.5664 1.54109 15.7096 1.27774 15.8055 1.08972C15.8535 0.995661 15.8897 0.920262 15.9145 0.867158C15.9268 0.840606 15.9364 0.819612 15.9431 0.804625C15.9464 0.797131 15.9491 0.791141 15.951 0.786705C15.952 0.784488 15.9527 0.782664 15.9534 0.781228C15.9537 0.780514 15.9539 0.779896 15.9542 0.779383C15.9543 0.779122 15.9547 0.778341 15.9548 0.778132C15.9548 0.778185 15.9548 0.778028 15.9548 0.778132C15.9548 0.778006 15.9548 0.778132 15.4417 0.558274ZM12.8272 3.2239C12.188 3.82385 11.4038 4.37908 10.4651 4.74856L10.8739 5.78727C11.9705 5.35565 12.8718 4.71299 13.5912 4.0378L12.8272 3.2239Z" />
      </svg>
    );
  }
  if (name === "google") {
    return (
      <svg
        className={classname}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.09674 10.0003C4.09674 9.35077 4.20462 8.72805 4.39717 8.14395L1.02692 5.57031C0.370072 6.90395 0 8.40668 0 10.0003C0 11.5926 0.369617 13.0944 1.02555 14.4271L4.39398 11.8485C4.20325 11.2671 4.09674 10.6467 4.09674 10.0003Z"
          fill="#FBBC05"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0142 4.09092C11.4253 4.09092 12.6999 4.59092 13.7013 5.4091L16.6145 2.50001C14.8393 0.954548 12.5633 0 10.0142 0C6.0568 0 2.6556 2.26319 1.02692 5.57001L4.39717 8.14365C5.17373 5.78638 7.38733 4.09092 10.0142 4.09092Z"
          fill="#EB4335"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0142 15.9092C7.38733 15.9092 5.17373 14.2137 4.39717 11.8564L1.02692 14.4296C2.6556 17.7369 6.0568 20.0001 10.0142 20.0001C12.4568 20.0001 14.7888 19.1328 16.539 17.5078L13.3399 15.0346C12.4372 15.6033 11.3006 15.9092 10.0142 15.9092Z"
          fill="#34A853"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.5732 9.99983C19.5732 9.40892 19.4822 8.77255 19.3456 8.18164H10.0142V12.0453H15.3854C15.1169 13.3626 14.3858 14.3753 13.3398 15.0344L16.5389 17.5076C18.3774 15.8012 19.5732 13.2594 19.5732 9.99983Z"
          fill="#4285F4"
        />
      </svg>
    );
  }
  if (name === "sun") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 19.75C16.9518 19.75 19.75 16.9518 19.75 13.5C19.75 10.0482 16.9518 7.25 13.5 7.25C10.0482 7.25 7.25 10.0482 7.25 13.5C7.25 16.9518 10.0482 19.75 13.5 19.75Z"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M13.5 1V3.5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M13.5 23.5V26"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M3.5 13.5H1"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M26 13.5H23.5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M23.2222 3.77832L20.4447 6.3178"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M3.77771 3.77832L6.55522 6.3178"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M6.55538 20.4446L3.77759 23.2224"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M23.2222 23.2216L20.4447 20.4439"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "moon") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.74419 12.5C1.74419 6.55977 6.55977 1.74419 12.5 1.74419V0C5.5964 0 0 5.5964 0 12.5H1.74419ZM12.5 1.74419C18.4403 1.74419 23.2558 6.55977 23.2558 12.5H25C25 5.5964 19.4036 0 12.5 0V1.74419ZM23.2558 12.5C23.2558 18.4403 18.4403 23.2558 12.5 23.2558V25C19.4036 25 25 19.4036 25 12.5H23.2558ZM8.43023 9.88372C12.1228 9.88372 15.1163 12.8772 15.1163 16.5698H16.8605C16.8605 11.9138 13.0862 8.13954 8.43023 8.13954V9.88372ZM2.70314 13.1174C3.87535 11.1776 6.00209 9.88372 8.43023 9.88372V8.13954C5.3664 8.13954 2.68523 9.77454 1.21023 12.2155L2.70314 13.1174ZM15.1163 16.5698C15.1163 18.9979 13.8224 21.1247 11.8826 22.2969L12.7845 23.7897C15.2255 22.3148 16.8605 19.6336 16.8605 16.5698H15.1163ZM12.5 23.2558C12.6029 23.2558 12.7236 23.3022 12.8112 23.3934C12.8853 23.4706 12.9026 23.5437 12.9066 23.5732C12.9115 23.6095 12.9091 23.7145 12.7845 23.7897L11.8826 22.2969C11.2974 22.6504 11.1093 23.2977 11.1781 23.8067C11.2495 24.3357 11.6667 25 12.5 25V23.2558ZM1.21023 12.2155C1.28558 12.0909 1.39058 12.0885 1.42674 12.0934C1.45628 12.0974 1.52942 12.1147 1.60663 12.1888C1.69779 12.2764 1.74419 12.3971 1.74419 12.5H0C0 13.3333 0.664303 13.7505 1.19337 13.8219C1.70233 13.8907 2.34965 13.7026 2.70314 13.1174L1.21023 12.2155Z"
          fill="#F6F6F6"
        />
      </svg>
    );
  }
  if (name === "quit") {
    return (
      <svg
        className={classname}
        width="27"
        height="29"
        viewBox="0 0 27 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M9.33334 4.37498H7.94445C4.67081 4.37498 3.03399 4.37498 2.01699 5.3635C1 6.35202 1 7.94301 1 11.125V17.875C1 21.057 1 22.6479 2.01699 23.6365C3.03399 24.625 4.67081 24.625 7.94445 24.625H9.33334"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M9.33337 7.04313C9.33337 3.94648 9.33337 2.39817 10.3157 1.55173C11.298 0.70529 12.7993 0.959833 15.8023 1.46892L19.0367 2.01726C22.3624 2.58108 24.0252 2.86297 25.0127 4.04864C26 5.23429 26 6.94906 26 10.3786V18.6214C26 22.051 26 23.7657 25.0127 24.9513C24.0252 26.137 22.3624 26.4189 19.0367 26.9828L15.8023 27.531C12.7993 28.0401 11.298 28.2947 10.3157 27.4483C9.33337 26.6018 9.33337 25.0535 9.33337 21.9569V7.04313Z"
          stroke="white"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M13.5 13.15V15.85"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "back") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.375 9.75L11.625 13.5L15.375 17.25"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M1 13.5C1 7.60744 1 4.66116 2.83059 2.83059C4.66116 1 7.60744 1 13.5 1C19.3925 1 22.3389 1 24.1694 2.83059C26 4.66116 26 7.60744 26 13.5C26 19.3925 26 22.3389 24.1694 24.1694C22.3389 26 19.3925 26 13.5 26C7.60744 26 4.66116 26 2.83059 24.1694C1 22.3389 1 19.3925 1 13.5Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "arrowLeft") {
    return (
      <svg
        className={classname}
        width="9"
        height="14"
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 1L1 7L8 13"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "dashboard") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 14.5C4.5 13.5572 4.5 13.0858 4.79289 12.7929C5.08579 12.5 5.55719 12.5 6.5 12.5H7.5C8.44281 12.5 8.91421 12.5 9.2071 12.7929C9.5 13.0858 9.5 13.5572 9.5 14.5V15.5C9.5 16.4428 9.5 16.9142 9.2071 17.2071C8.91421 17.5 8.44281 17.5 7.5 17.5C6.08579 17.5 5.37868 17.5 4.93934 17.0607C4.5 16.6213 4.5 15.9142 4.5 14.5Z"
          stroke-width="2"
        />
        <path
          d="M4.5 7.5C4.5 6.08579 4.5 5.37868 4.93934 4.93934C5.37868 4.5 6.08579 4.5 7.5 4.5C8.44281 4.5 8.91421 4.5 9.2071 4.79289C9.5 5.08579 9.5 5.55719 9.5 6.5V7.5C9.5 8.44281 9.5 8.91421 9.2071 9.2071C8.91421 9.5 8.44281 9.5 7.5 9.5H6.5C5.55719 9.5 5.08579 9.5 4.79289 9.2071C4.5 8.91421 4.5 8.44281 4.5 7.5Z"
          stroke-width="2"
        />
        <path
          d="M12.5 14.5C12.5 13.5572 12.5 13.0858 12.7929 12.7929C13.0858 12.5 13.5572 12.5 14.5 12.5H15.5C16.4428 12.5 16.9142 12.5 17.2071 12.7929C17.5 13.0858 17.5 13.5572 17.5 14.5C17.5 15.9142 17.5 16.6213 17.0607 17.0607C16.6213 17.5 15.9142 17.5 14.5 17.5C13.5572 17.5 13.0858 17.5 12.7929 17.2071C12.5 16.9142 12.5 16.4428 12.5 15.5V14.5Z"
          stroke-width="2"
        />
        <path
          d="M12.5 6.5C12.5 5.55719 12.5 5.08579 12.7929 4.79289C13.0858 4.5 13.5572 4.5 14.5 4.5C15.9142 4.5 16.6213 4.5 17.0607 4.93934C17.5 5.37868 17.5 6.08579 17.5 7.5C17.5 8.44281 17.5 8.91421 17.2071 9.2071C16.9142 9.5 16.4428 9.5 15.5 9.5H14.5C13.5572 9.5 13.0858 9.5 12.7929 9.2071C12.5 8.91421 12.5 8.44281 12.5 7.5V6.5Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M21 13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M9 21C5.22876 21 3.34315 21 2.17157 19.8284C1 18.6569 1 16.7712 1 13"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M9 1C5.22876 1 3.34315 1 2.17157 2.17157C1 3.34315 1 5.22876 1 9"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M13 1C16.7712 1 18.6569 1 19.8284 2.17157C21 3.34315 21 5.22876 21 9"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "challenge") {
    return (
      <svg
        className={classname}
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1H13C16.7712 1 18.6569 1 19.8284 2.17157C21 3.34315 21 5.22876 21 9C21 12.7712 21 14.6569 19.8284 15.8284C18.6569 17 16.7712 17 13 17H9C5.22876 17 3.34315 17 2.17157 15.8284C1 14.6569 1 12.7712 1 9Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M9 13.5H5"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M7 10.5H5"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M1 7H21"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M13 12C13 11.0572 13 10.5858 13.2929 10.2929C13.5858 10 14.0572 10 15 10C15.9428 10 16.4142 10 16.7071 10.2929C17 10.5858 17 11.0572 17 12C17 12.9428 17 13.4142 16.7071 13.7071C16.4142 14 15.9428 14 15 14C14.0572 14 13.5858 14 13.2929 13.7071C13 13.4142 13 12.9428 13 12Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "transaction") {
    return (
      <svg
        className={classname}
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.9991 8C20.99 4.8857 20.8915 3.23467 19.8284 2.17157C18.6569 1 16.7712 1 13 1H8.99999C5.22876 1 3.34315 1 2.17157 2.17157C1 3.34315 1 5.22876 1 9C1 12.7712 1 14.6569 2.17157 15.8284C3.34315 17 5.22876 17 8.99999 17H10.5"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M19 17V11M19 11L21 13M19 11L17 13"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5 11V17M14.5 17L16.5 15M14.5 17L12.5 15"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M9.00001 13H5.00002"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.4"
          d="M1 7H21"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "challengeManage") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M2 11C2 14.7712 2 18.6569 3.31802 19.8284C4.63604 21 6.75736 21 11 21C15.2426 21 17.364 21 18.682 19.8284C20 18.6569 20 14.7712 20 11"
          stroke-width="2"
        />
        <path
          d="M13.6603 13.2019L19.6676 11.3997C20.2631 11.2211 20.5609 11.1317 20.7498 10.9176C20.7866 10.8759 20.8199 10.8312 20.8492 10.784C21 10.5415 21 10.2307 21 9.6089C21 7.15877 21 5.9337 20.327 5.10659C20.1977 4.94763 20.0524 4.80233 19.8934 4.67298C19.0663 4 17.8412 4 15.3911 4H6.60893C4.15877 4 2.9337 4 2.10659 4.67298C1.94763 4.80233 1.80233 4.94763 1.67298 5.10659C1 5.9337 1 7.15877 1 9.6089C1 10.2307 1 10.5415 1.15078 10.784C1.18015 10.8312 1.21341 10.8759 1.25021 10.9176C1.43915 11.1317 1.7369 11.2211 2.3324 11.3997L8.33968 13.2019"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M5.5 4C6.32344 3.97913 7.15925 3.45491 7.43944 2.68032C7.44806 2.65649 7.4569 2.62999 7.47457 2.57697L7.50023 2.5C7.54241 2.37344 7.56351 2.31014 7.58608 2.254C7.87427 1.53712 8.54961 1.05037 9.3208 1.00366C9.3812 1 9.4479 1 9.5814 1H12.4191C12.5525 1 12.6192 1 12.6796 1.00366C13.4508 1.05037 14.1262 1.53712 14.4144 2.254C14.4369 2.31014 14.458 2.37343 14.5002 2.5L14.5259 2.57697C14.5435 2.62968 14.5524 2.65656 14.561 2.68032C14.8412 3.45491 15.6766 3.97913 16.5 4"
          stroke-width="2"
        />
        <path
          d="M13 11.5H9C8.72386 11.5 8.5 11.7239 8.5 12V14.1615C8.5 14.3659 8.62448 14.5498 8.8143 14.6257L9.5144 14.9058C10.4681 15.2872 11.5319 15.2872 12.4856 14.9058L13.1857 14.6257C13.3755 14.5498 13.5 14.3659 13.5 14.1615V12C13.5 11.7239 13.2761 11.5 13 11.5Z"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "userManage") {
    return (
      <svg
        className={classname}
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.46092 8.35006C10.5902 8.35006 12.3164 6.64873 12.3164 4.55003C12.3164 2.45133 10.5902 0.75 8.46092 0.75C6.33161 0.75 4.60547 2.45133 4.60547 4.55003C4.60547 6.64873 6.33161 8.35006 8.46092 8.35006Z"
          stroke-width="1.5"
        />
        <path
          opacity="0.5"
          d="M16.1719 15.475C16.1719 17.836 16.1719 19.75 8.46102 19.75C0.750122 19.75 0.750122 17.836 0.750122 15.475C0.750122 13.1139 4.20241 11.2 8.46102 11.2C12.7197 11.2 16.1719 13.1139 16.1719 15.475Z"
          stroke-width="1.5"
        />
        <path d="M16.6354 11.2721C16.6198 11.264 16.6037 11.2571 16.5885 11.2487H16.5875C16.5701 11.239 16.5541 11.2268 16.5367 11.2164L16.6354 11.0885V11.2721ZM17.733 11.2164L17.6832 11.2487C17.6679 11.2572 17.6511 11.2639 17.6354 11.2721V11.0885L17.733 11.2164ZM14.5338 8.56506C14.6326 8.93764 14.8359 9.25279 15.0983 9.53479C15.3623 9.81842 15.6763 10.0589 15.9889 10.2906L15.7233 10.6334C15.4012 10.3948 15.0547 10.128 14.7653 9.81702C14.4443 9.4722 14.1824 9.06447 14.0748 8.56506H14.5338ZM20.1959 8.56506C20.106 8.98233 19.9098 9.33617 19.6598 9.64221L19.5065 9.81702C19.2169 10.1282 18.8688 10.3937 18.5465 10.6324L18.2819 10.2906C18.5946 10.0588 18.9094 9.81851 19.1735 9.53479C19.4358 9.25283 19.6392 8.93758 19.7379 8.56506H20.1959ZM18.0778 6.27991C18.4574 6.19613 18.8308 6.23815 19.1617 6.38245C19.6566 6.59827 20.0335 7.03412 20.1813 7.56506H19.7125C19.5795 7.20303 19.3104 6.91493 18.9762 6.76917H18.9772C18.7752 6.68107 18.5201 6.63347 18.235 6.68323L18.361 6.56116L18.0778 6.27991ZM15.109 6.38245C15.4399 6.23811 15.8134 6.19623 16.193 6.27991L15.9108 6.56116L16.0358 6.68323C15.7509 6.6336 15.4964 6.68115 15.2946 6.76917C14.9603 6.91495 14.6912 7.20296 14.5582 7.56506H14.0895C14.2373 7.03409 14.6142 6.5983 15.109 6.38245Z" />
      </svg>
    );
  }
  if (name === "userKYC") {
    return (
      <svg
        className={classname}
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.75012 7.75C8.85469 7.75 9.75012 6.85457 9.75012 5.75C9.75012 4.64543 8.85469 3.75 7.75012 3.75C6.64555 3.75 5.75012 4.64543 5.75012 5.75C5.75012 6.85457 6.64555 7.75 7.75012 7.75Z"
          stroke-width="1.5"
        />
        <path
          d="M11.75 11.75C11.75 12.8546 11.75 13.75 7.75 13.75C3.75 13.75 3.75 12.8546 3.75 11.75C3.75 10.6454 5.54086 9.75 7.75 9.75C9.9591 9.75 11.75 10.6454 11.75 11.75Z"
          stroke-width="1.5"
        />
        <path
          opacity="0.5"
          d="M0.75 8.75C0.75 4.97876 0.75 3.09315 1.92157 1.92157C3.09315 0.75 4.97876 0.75 8.75 0.75H12.75C16.5212 0.75 18.4069 0.75 19.5784 1.92157C20.75 3.09315 20.75 4.97876 20.75 8.75C20.75 12.5212 20.75 14.4069 19.5784 15.5784C18.4069 16.75 16.5212 16.75 12.75 16.75H8.75C4.97876 16.75 3.09315 16.75 1.92157 15.5784C0.75 14.4069 0.75 12.5212 0.75 8.75Z"
          stroke-width="1.5"
        />
        <path
          d="M17.7501 8.74988H13.7501"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.75 5.74988H12.75"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          opacity="0.9"
          d="M17.7501 11.7499H14.7501"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "userSupport") {
    return (
      <svg
        className={classname}
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.92106 9.17109C12.2464 9.17109 14.1315 7.286 14.1315 4.96061C14.1315 2.63522 12.2464 0.750122 9.92106 0.750122C7.59567 0.750122 5.71057 2.63522 5.71057 4.96061C5.71057 7.286 7.59567 9.17109 9.92106 9.17109Z"
          stroke-width="1.5"
        />
        <path
          opacity="0.5"
          d="M18.3419 17.0659C18.3419 19.682 18.3419 21.8027 9.92097 21.8027C1.5 21.8027 1.5 19.682 1.5 17.0659C1.5 14.4498 5.2702 12.3291 9.92097 12.3291C14.5718 12.3291 18.3419 14.4498 18.3419 17.0659Z"
          stroke-width="1.5"
        />
        <path
          d="M19.3948 0.750122C19.3948 0.750122 21.5 2.01327 21.5 4.96061C21.5 7.90795 19.3948 9.17109 19.3948 9.17109"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.2893 2.85559C17.2893 2.85559 18.3419 3.48716 18.3419 4.96083C18.3419 6.4345 17.2893 7.06608 17.2893 7.06608"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "managers") {
    return (
      <svg
        className={classname}
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 20.2501L17.3505 14.7296C17.1506 13.0305 15.7107 11.7501 14 11.7501H6C4.28928 11.7501 2.84936 13.0305 2.64948 14.7296L2 20.2501"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M5.99988 11.7501V16.7501C5.99988 18.6357 5.99988 19.5785 6.58567 20.1643C7.17145 20.7501 8.11428 20.7501 9.99988 20.7501C11.8855 20.7501 12.8283 20.7501 13.4141 20.1643C13.9999 19.5785 13.9999 18.6357 13.9999 16.7501V11.7501"
          stroke-width="1.5"
        />
        <path
          d="M9.99988 8.75C12.209 8.75 13.9999 6.95914 13.9999 4.75C13.9999 2.54086 12.209 0.75 9.99988 0.75C7.79074 0.75 5.99988 2.54086 5.99988 4.75C5.99988 6.95914 7.79074 8.75 9.99988 8.75Z"
          stroke-width="1.5"
        />
      </svg>
    );
  }
  if (name === "blog") {
    return (
      <svg
        className={classname}
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 8.75C1 4.97876 1 3.09315 2.17157 1.92157C3.34315 0.75 5.22876 0.75 9 0.75H11C14.7712 0.75 16.6569 0.75 17.8284 1.92157C19 3.09315 19 4.97876 19 8.75V12.75C19 16.5212 19 18.4069 17.8284 19.5784C16.6569 20.75 14.7712 20.75 11 20.75H9C5.22876 20.75 3.34315 20.75 2.17157 19.5784C1 18.4069 1 16.5212 1 12.75V8.75Z"
          stroke-width="1.5"
        />
        <path
          opacity="0.5"
          d="M4 10.75C4 9.3358 4 8.62868 4.43934 8.18934C4.87868 7.75 5.58579 7.75 7 7.75H13C14.4142 7.75 15.1213 7.75 15.5607 8.18934C16 8.62868 16 9.3358 16 10.75V14.75C16 16.1642 16 16.8713 15.5607 17.3107C15.1213 17.75 14.4142 17.75 13 17.75H7C5.58579 17.75 4.87868 17.75 4.43934 17.3107C4 16.8713 4 16.1642 4 14.75V10.75Z"
          stroke-width="1.5"
        />
        <path
          opacity="0.5"
          d="M10 4.75H15"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "log") {
    return (
      <svg
        className={classname}
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M19.5 5V11C19.5 14.7712 19.5 16.6569 18.3284 17.8284C17.1569 19 15.2712 19 11.5 19H10.5C6.72876 19 4.84315 19 3.67157 17.8284C2.5 16.6569 2.5 14.7712 2.5 11V5"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M1 3C1 2.05719 1 1.58579 1.29289 1.29289C1.58579 1 2.05719 1 3 1H19C19.9428 1 20.4142 1 20.7071 1.29289C21 1.58579 21 2.05719 21 3C21 3.94281 21 4.4142 20.7071 4.7071C20.4142 4.99999 19.9428 4.99999 19 4.99999H3C2.05719 4.99999 1.58579 4.99999 1.29289 4.7071C1 4.4142 1 3.94281 1 3Z"
          stroke-width="2"
        />
        <path
          d="M8.50012 11.4L9.92872 13L13.5001 9"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "trade") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 13C1 9.2288 1 7.34315 2.17157 6.17157C3.34315 5 5.22876 5 9 5H13C16.7712 5 18.6569 5 19.8284 6.17157C21 7.34315 21 9.2288 21 13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H9C5.22876 21 3.34315 21 2.17157 19.8284C1 18.6569 1 16.7712 1 13Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M15 5C15 3.11438 15 2.17157 14.4142 1.58579C13.8284 1 12.8856 1 11 1C9.1144 1 8.17157 1 7.58579 1.58579C7 2.17157 7 3.11438 7 5"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M11 16.3333C12.1046 16.3333 13 15.5871 13 14.6667C13 13.7462 12.1046 13 11 13C9.8954 13 9 12.2538 9 11.3333C9 10.4129 9.8954 9.6667 11 9.6667M11 16.3333C9.8954 16.3333 9 15.5871 9 14.6667M11 16.3333V17M11 9.6667V9M11 9.6667C12.1046 9.6667 13 10.4129 13 11.3333"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "competition") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0003 15C5.24024 15 4.21986 9.2595 4.0391 4.70647C3.98882 3.43998 3.96368 2.80673 4.4394 2.22083C4.91511 1.63494 5.48448 1.53887 6.62322 1.34674C7.74728 1.15709 9.21665 1 11.0003 1C12.7838 1 14.2532 1.15709 15.3772 1.34674C16.516 1.53887 17.0853 1.63494 17.561 2.22083C18.0368 2.80673 18.0116 3.43998 17.9613 4.70647C17.7806 9.2595 16.7602 15 11.0003 15Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M18.0001 4L18.9487 4.31621C19.9388 4.64623 20.4338 4.81124 20.7169 5.20408C21.0001 5.59692 21.0001 6.11873 21 7.16234V7.23487C21 8.09561 21 8.52598 20.7928 8.87809C20.5856 9.2302 20.2094 9.4392 19.457 9.8572L16.5001 11.5"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M3.99996 4L3.05134 4.31621C2.06127 4.64623 1.56624 4.81124 1.28311 5.20408C0.999968 5.59692 0.999978 6.11873 1.00001 7.16234V7.23487C1.00004 8.09561 1.00005 8.52598 1.20724 8.87809C1.41442 9.2302 1.79064 9.4392 2.54307 9.8572L5.49997 11.5"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M11.0001 16V18"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M14.5001 21H7.50004L7.83926 19.3039C7.93275 18.8365 8.34317 18.5 8.81985 18.5H13.1803C13.657 18.5 14.0674 18.8365 14.1609 19.3039L14.5001 21Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M17.0001 21H5.00003"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "invite") {
    return (
      <svg
        className={classname}
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.00002 5C2.00002 3.11438 2.00002 2.17157 2.58581 1.58579C3.17159 1 4.1144 1 6.00002 1H12C13.8856 1 14.8284 1 15.4142 1.58579C16 2.17157 16 3.11438 16 5V9.99999C16 12.8284 16 14.2426 15.1213 15.1213C14.2426 16 12.8284 16 10 16H8.00002C5.17159 16 3.75738 16 2.8787 15.1213C2.00002 14.2426 2.00002 12.8284 2.00002 9.99999V5Z"
          stroke-width="2"
        />
        <path
          d="M16 11H17C19.2091 11 21 9.2091 21 7C21 4.79086 19.2091 3 17 3H16"
          stroke-width="2"
        />
        <path opacity="0.5" d="M16 11H2.00002" stroke-width="2" />
        <path
          opacity="0.5"
          d="M21 19H1"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "discount") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M21 11H1"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M11 1V21"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M12 11C12 13.2091 13.7909 15 16 15"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M10 11C10 13.2091 8.20914 15 6 15"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M11 9.0352C11 7.54529 12.014 6.24659 13.4594 5.88524C15.0631 5.48431 16.5158 6.93697 16.1148 8.5407C15.7535 9.9861 14.4548 11.0001 12.9649 11.0001H11V9.0352Z"
          stroke-width="2"
        />
        <path
          d="M11.0001 9.0352C11.0001 7.54529 9.9861 6.24659 8.5407 5.88524C6.93698 5.48431 5.48431 6.93697 5.88524 8.5407C6.24659 9.9861 7.54529 11.0001 9.0352 11.0001H11.0001V9.0352Z"
          stroke-width="2"
        />
        <path
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "certificate") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M6 16.6361C3.82497 16.6243 2.64706 16.53 1.87868 15.779C1 14.9202 1 13.538 1 10.7736V6.86418C1 4.09978 1 2.71758 1.87868 1.85879C2.75736 1 4.17157 1 7 1H15C17.8284 1 19.2426 1 20.1213 1.85879C21 2.71758 21 4.09978 21 6.86418V10.7736C21 13.538 21 14.9202 20.1213 15.779C19.3915 16.4924 18.2921 16.6132 16.3197 16.6336L15.5 16.6361"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M8 4.90942H14"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M6 8.3302H16"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M9.89071 12.675C10.53 12.1427 11.4702 12.1427 12.1094 12.675C12.3833 12.9032 12.7239 13.0412 13.0827 13.0691C13.9199 13.1344 14.5847 13.7841 14.6515 14.6024C14.6802 14.9531 14.8212 15.286 15.0547 15.5537C15.5994 16.1785 15.5994 17.0974 15.0547 17.7221C14.8212 17.9898 14.6802 18.3227 14.6515 18.6734C14.5847 19.4917 13.9199 20.1414 13.0827 20.2067C12.7239 20.2347 12.3833 20.3726 12.1094 20.6008C11.4702 21.1331 10.53 21.1331 9.89071 20.6008C9.61681 20.3726 9.27621 20.2347 8.91744 20.2067C8.08022 20.1414 7.4154 19.4917 7.34859 18.6734C7.31996 18.3227 7.17889 17.9898 6.94544 17.7221C6.40069 17.0974 6.40069 16.1785 6.94544 15.5537C7.17889 15.286 7.31996 14.9531 7.34859 14.6024C7.41541 13.7841 8.08022 13.1344 8.91744 13.0691C9.27621 13.0412 9.61681 12.9032 9.89071 12.675Z"
          stroke-width="2"
        />
        <path
          d="M9.5 16.8332L10.3571 17.6151L12.5 15.6604"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "point") {
    return (
      <svg
        className={classname}
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M10.1448 6.02251C10.5248 5.34084 10.7148 5 10.9989 5C11.283 5 11.473 5.34084 11.853 6.02251L11.9513 6.19887C12.0592 6.39258 12.1132 6.48944 12.1974 6.55334C12.2816 6.61725 12.3864 6.64097 12.5961 6.68841L12.787 6.73161C13.5249 6.89857 13.8939 6.98205 13.9817 7.26432C14.0695 7.54659 13.8179 7.84072 13.3149 8.42899L13.1847 8.58118C13.0418 8.74834 12.9703 8.83192 12.9381 8.93532C12.906 9.03871 12.9168 9.15021 12.9384 9.37331L12.9581 9.57631C13.0341 10.3612 13.0722 10.7536 12.8424 10.9281C12.6125 11.1025 12.2671 10.9435 11.5762 10.6254L11.3975 10.5431C11.2011 10.4527 11.103 10.4075 10.9989 10.4075C10.8948 10.4075 10.7967 10.4527 10.6003 10.5431L10.4216 10.6254C9.73075 10.9435 9.38535 11.1025 9.15545 10.9281C8.92569 10.7536 8.96371 10.3612 9.03975 9.57631L9.05945 9.37331C9.08105 9.15021 9.09185 9.03871 9.05975 8.93532C9.02755 8.83192 8.95608 8.74834 8.81313 8.58118L8.68298 8.42899C8.17992 7.84072 7.9284 7.54659 8.01618 7.26432C8.10396 6.98205 8.47291 6.89857 9.21085 6.73161L9.40175 6.68841C9.61145 6.64097 9.71625 6.61725 9.80045 6.55334C9.88465 6.48944 9.93865 6.39258 10.0465 6.19887L10.1448 6.02251Z"
          stroke-width="2"
        />
        <path
          d="M17.9989 8.00001C17.9989 11.866 14.8649 15 10.9989 15C7.13296 15 3.99895 11.866 3.99895 8.00001C3.99895 4.13402 7.13296 1 10.9989 1C14.8649 1 17.9989 4.13402 17.9989 8.00001Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M10.9989 15.0678L7.2275 18.9728C6.68738 19.5321 6.41732 19.8117 6.18862 19.9084C5.66747 20.1289 5.08937 19.9402 4.81523 19.4602C4.69492 19.2495 4.65743 18.8695 4.58245 18.1095C4.54012 17.6804 4.51895 17.4658 4.4547 17.2861C4.31086 16.8838 4.00861 16.5708 3.62005 16.4219C3.44649 16.3554 3.23928 16.3335 2.82484 16.2896C2.09082 16.212 1.72381 16.1732 1.52033 16.0486C1.05667 15.7648 0.874428 15.1662 1.08738 14.6266C1.18083 14.3898 1.45089 14.1102 1.99101 13.5509L4.4547 11"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M10.9989 15.0678L14.7704 18.9728C15.3105 19.5321 15.5805 19.8117 15.8092 19.9084C16.3304 20.1289 16.9085 19.9402 17.1826 19.4602C17.3029 19.2495 17.3404 18.8695 17.4154 18.1095C17.4577 17.6804 17.4789 17.4658 17.5431 17.2861C17.687 16.8838 17.9892 16.5708 18.3778 16.4219C18.5514 16.3554 18.7586 16.3335 19.173 16.2896C19.907 16.212 20.274 16.1732 20.4775 16.0486C20.9412 15.7648 21.1234 15.1662 20.9105 14.6266C20.817 14.3898 20.547 14.1102 20.0068 13.5509L17.5431 11"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "profile") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
          stroke-width="2"
        />
        <path
          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M16.9691 19C16.81 16.1085 15.9247 14 10.9999 14C6.07521 14 5.18991 16.1085 5.03076 19"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "notification") {
    return (
      <svg
        className={classname}
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4981 9.48053V8.70547C18.4981 4.44985 15.1407 1 10.9991 1C6.85751 1 3.50008 4.44985 3.50008 8.70547V9.48053C3.50008 10.4107 3.23214 11.32 2.73 12.0939L1.49952 13.9905C0.375583 15.7227 1.23362 18.0774 3.1884 18.6252C8.30216 20.0583 13.6961 20.0583 18.8098 18.6252C20.7647 18.0774 21.6227 15.7227 20.4987 13.9905L19.2682 12.0939C18.7661 11.32 18.4981 10.4107 18.4981 9.48053Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M5.99911 19.7C6.72693 21.6225 8.69074 23 10.9991 23C13.3074 23 15.2713 21.6225 15.9991 19.7"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M10.9991 5.40002V9.80003"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "support") {
    return (
      <svg
        className={classname}
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1H13C16.7712 1 18.6569 1 19.8284 2.17157C21 3.34315 21 5.22876 21 9C21 12.7712 21 14.6569 19.8284 15.8284C18.6569 17 16.7712 17 13 17H9C5.22876 17 3.34315 17 2.17157 15.8284C1 14.6569 1 12.7712 1 9Z"
          stroke-width="2"
        />
        <path
          d="M5 5L7.1589 6.79908C8.99553 8.3296 9.9139 9.0949 11 9.0949C12.0861 9.0949 13.0045 8.3296 14.8411 6.79908L17 5"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "rules") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M21 9.5V11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1H12.5"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M18 7C19.6569 7 21 5.65685 21 4C21 2.34315 19.6569 1 18 1C16.3431 1 15 2.34315 15 4C15 5.65685 16.3431 7 18 7Z"
          stroke-width="2"
        />
        <path d="M6 13H15" stroke-width="2" stroke-linecap="round" />
        <path d="M6 16.5H12" stroke-width="2" stroke-linecap="round" />
      </svg>
    );
  }
  if (name === "minimize") {
    return (
      <svg
        className={classname}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 15C1 8.40033 1 5.1005 3.05026 3.05026C5.1005 1 8.40033 1 15 1C21.5996 1 24.8995 1 26.9497 3.05026C29 5.1005 29 8.40033 29 15C29 21.5996 29 24.8995 26.9497 26.9497C24.8995 29 21.5996 29 15 29C8.40033 29 5.1005 29 3.05026 26.9497C1 24.8995 1 21.5996 1 15Z"
          stroke-width="2"
        />
        <path
          d="M12.9 17.1H8.7M12.9 17.1V21.3M12.9 17.1L8 22"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.1001 12.9H21.3001M17.1001 12.9V8.69999M17.1001 12.9L22.0001 7.99999"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "maximize") {
    return (
      <svg
        className={classname}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 15C1 8.40033 1 5.1005 3.05026 3.05026C5.1005 1 8.40033 1 15 1C21.5996 1 24.8995 1 26.9497 3.05026C29 5.1005 29 8.40033 29 15C29 21.5996 29 24.8995 26.9497 26.9497C24.8995 29 21.5996 29 15 29C8.40033 29 5.1005 29 3.05026 26.9497C1 24.8995 1 21.5996 1 15Z"
          stroke-width="2"
        />
        <path
          d="M7.02017 22.98H11.2202M7.02017 22.98V18.78M7.02017 22.98L11.9202 18.08"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.98 7.02H18.78M22.98 7.02V11.22M22.98 7.02L18.08 11.92"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "profitAvailable") {
    return (
      <svg
        className={classname}
        style={style}
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.4444 3.2002C17.8611 3.21352 19.1699 3.31962 20.0237 4.16491C21 5.13154 21 6.68731 21 9.79884V16.3995C21 19.511 21 21.0667 20.0237 22.0334C19.0473 23 17.476 23 14.3333 23H7.66667C4.52397 23 2.95262 23 1.97631 22.0334C1 21.0667 1 19.511 1 16.3995V9.79884C1 6.68731 1 5.13154 1.97631 4.16491C2.83007 3.31962 4.13886 3.21352 6.55556 3.2002"
          stroke="white"
          stroke-opacity="0.5"
          stroke-width="2"
        />
        <path
          d="M6.55566 2.65014C6.55566 1.73879 7.30185 1 8.22233 1H13.7779C14.6983 1 15.4446 1.73879 15.4446 2.65014V3.75023C15.4446 4.66159 14.6983 5.40038 13.7779 5.40038H8.22233C7.30185 5.40038 6.55566 4.66159 6.55566 3.75023V2.65014Z"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M14.3334 13.1011H11.0001M11.0001 13.1011H7.66675M11.0001 13.1011V9.80078M11.0001 13.1011V16.4013"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "profitProcess") {
    return (
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M15.4444 3.2002C17.8611 3.21352 19.1699 3.31962 20.0237 4.16491C21 5.13154 21 6.68731 21 9.79884V16.3995C21 19.511 21 21.0667 20.0237 22.0334C19.0473 23 17.476 23 14.3333 23H7.66667C4.52397 23 2.95262 23 1.97631 22.0334C1 21.0667 1 19.511 1 16.3995V9.79884C1 6.68731 1 5.13154 1.97631 4.16491C2.83007 3.31962 4.13886 3.21352 6.55556 3.2002"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M6.55554 2.65014C6.55554 1.73879 7.30173 1 8.22221 1H13.7778C14.6982 1 15.4444 1.73879 15.4444 2.65014V3.75023C15.4444 4.66159 14.6982 5.40038 13.7778 5.40038H8.22221C7.30173 5.40038 6.55554 4.66159 6.55554 3.75023V2.65014Z"
          stroke="white"
          stroke-width="2"
        />
        <g clip-path="url(#clip0_930_4)">
          <circle cx="7.5" cy="13" r="1" fill="white" />
          <circle cx="11" cy="13" r="1" fill="white" />
          <circle cx="14.5" cy="13" r="1" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_930_4">
            <rect
              width="9"
              height="2"
              fill="white"
              transform="translate(6.5 12)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === "profitDone") {
    return (
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M15.4444 3.2002C17.8611 3.21352 19.1699 3.31962 20.0237 4.16491C21 5.13154 21 6.6873 21 9.79884V16.3994C21 19.5109 21 21.0667 20.0237 22.0333C19.0473 23 17.476 23 14.3333 23H7.66667C4.52397 23 2.95262 23 1.97631 22.0333C1 21.0667 1 19.5109 1 16.3994V9.79884C1 6.6873 1 5.13154 1.97631 4.16491C2.83007 3.31962 4.13886 3.21352 6.55556 3.2002"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M7.66669 13.5411L9.57146 15.3013L14.3334 10.9009"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.55554 2.65014C6.55554 1.73879 7.30173 1 8.22221 1H13.7778C14.6982 1 15.4444 1.73879 15.4444 2.65014V3.75023C15.4444 4.66158 14.6982 5.40037 13.7778 5.40037H8.22221C7.30173 5.40037 6.55554 4.66158 6.55554 3.75023V2.65014Z"
          stroke="white"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "link") {
    return (
      <svg
        className={classname}
        style={style}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M25 13C25 18.6568 25 21.4853 23.2426 23.2426C21.4853 25 18.6568 25 13 25C7.34314 25 4.51472 25 2.75736 23.2426C1 21.4853 1 18.6568 1 13C1 7.34314 1 4.51472 2.75736 2.75736C4.51472 1 7.34314 1 13 1"
          stroke-opacity="0.5"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M17.9859 2.72118L20.8146 5.17274C22.7619 6.86034 23.7354 7.70414 23.7354 8.80005C23.7354 9.89596 22.7619 10.7398 20.8146 12.4273L17.9859 14.8789C17.1297 15.621 16.7015 15.992 16.3508 15.8318C16 15.6716 16 15.1051 16 13.9721V12.1429C12.4 12.1429 8.5 13.8144 7 16.6001C7 7.68577 12.3333 5.45719 16 5.45719V3.628C16 2.49494 16 1.92841 16.3508 1.76823C16.7015 1.60807 17.1297 1.9791 17.9859 2.72118Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "copy") {
    return (
      <svg
        className={classname}
        style={style}
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.33301 5.8998C2.33301 4.20275 2.33301 3.35422 2.86998 2.82701C3.40695 2.2998 4.27119 2.2998 5.99967 2.2998H7.83301C9.56147 2.2998 10.4257 2.2998 10.9627 2.82701C11.4997 3.35422 11.4997 4.20275 11.4997 5.8998V8.8998C11.4997 10.5968 11.4997 11.4454 10.9627 11.9726C10.4257 12.4998 9.56147 12.4998 7.83301 12.4998H5.99967C4.27119 12.4998 3.40695 12.4998 2.86998 11.9726C2.33301 11.4454 2.33301 10.5968 2.33301 8.8998V5.8998Z" />
        <path
          opacity="0.5"
          d="M2.33333 10.7C1.32081 10.7 0.5 9.89414 0.5 8.9V5.3C0.5 3.03726 0.5 1.90589 1.21596 1.20294C1.93192 0.5 3.08424 0.5 5.38889 0.5H7.83333C8.84588 0.5 9.66667 1.30589 9.66667 2.3"
        />
      </svg>
    );
  }
  if (name === "notifs") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6113 19.0881L12.1155 18.2362L10.9147 17.5254L10.4104 18.3774L11.6113 19.0881ZM7.88446 18.2362L8.38875 19.0881L9.58949 18.3774L9.08521 17.5254L7.88446 18.2362ZM10.4104 18.3774C10.2312 18.6803 9.76884 18.6803 9.58949 18.3774L8.38875 19.0881C9.10837 20.304 10.8916 20.304 11.6113 19.0881L10.4104 18.3774ZM8.60465 1.39535H11.3953V1.91679e-07H8.60465V1.39535ZM18.6047 8.60467V9.53491H20V8.60467H18.6047ZM1.39535 9.53491V8.60467H1.91678e-07V9.53491H1.39535ZM1.91678e-07 9.53491C1.91678e-07 10.609 -0.000381234 11.4494 0.0458699 12.1273C0.0925583 12.8115 0.189051 13.3809 0.407154 13.9074L1.69629 13.3734C1.56034 13.0452 1.47982 12.6454 1.43799 12.0323C1.39573 11.413 1.39535 10.628 1.39535 9.53491H1.91678e-07ZM6.09535 15.8062C4.9275 15.786 4.31556 15.7118 3.8359 15.5131L3.30193 16.8022C4.05074 17.1123 4.90361 17.1812 6.07131 17.2013L6.09535 15.8062ZM0.407154 13.9074C0.950028 15.218 1.99131 16.2593 3.30193 16.8022L3.8359 15.5131C2.86718 15.1118 2.09754 14.3422 1.69629 13.3734L0.407154 13.9074ZM18.6047 9.53491C18.6047 10.628 18.6043 11.413 18.562 12.0323C18.5202 12.6454 18.4396 13.0452 18.3037 13.3734L19.5928 13.9074C19.811 13.3809 19.9074 12.8115 19.9541 12.1273C20.0004 11.4494 20 10.609 20 9.53491H18.6047ZM13.9287 17.2013C15.0964 17.1812 15.9493 17.1123 16.698 16.8022L16.1641 15.5131C15.6845 15.7118 15.0725 15.786 13.9047 15.8062L13.9287 17.2013ZM18.3037 13.3734C17.9024 14.3422 17.1328 15.1118 16.1641 15.5131L16.698 16.8022C18.0087 16.2593 19.05 15.218 19.5928 13.9074L18.3037 13.3734ZM11.3953 1.39535C12.9313 1.39535 14.0344 1.39609 14.8948 1.47789C15.7448 1.55871 16.2857 1.71371 16.7168 1.97794L17.446 0.788207C16.7586 0.367043 15.979 0.17934 15.0269 0.0888097C14.0851 -0.000734733 12.9044 1.91679e-07 11.3953 1.91679e-07V1.39535ZM20 8.60467C20 7.09565 20.0007 5.9149 19.9112 4.97314C19.8207 4.021 19.6329 3.24136 19.2118 2.55408L18.022 3.28315C18.2863 3.71434 18.4413 4.25521 18.5221 5.10521C18.6039 5.9656 18.6047 7.06863 18.6047 8.60467H20ZM16.7168 1.97794C17.2488 2.30393 17.6961 2.75119 18.022 3.28315L19.2118 2.55408C18.7708 1.83437 18.1657 1.22925 17.446 0.788207L16.7168 1.97794ZM8.60465 1.91679e-07C7.09564 1.91679e-07 5.91488 -0.000734733 4.97313 0.0888097C4.02099 0.17934 3.24135 0.367043 2.55407 0.788207L3.28314 1.97794C3.71433 1.71371 4.2552 1.55871 5.1052 1.47789C5.96558 1.39609 7.06861 1.39535 8.60465 1.39535V1.91679e-07ZM1.39535 8.60467C1.39535 7.06863 1.39608 5.9656 1.47789 5.10521C1.55871 4.25521 1.7137 3.71434 1.97794 3.28315L0.788205 2.55408C0.367042 3.24136 0.17934 4.021 0.0888095 4.97314C-0.000734731 5.9149 1.91678e-07 7.09565 1.91678e-07 8.60467H1.39535ZM2.55407 0.788207C1.83436 1.22925 1.22925 1.83437 0.788205 2.55408L1.97794 3.28315C2.30393 2.75119 2.75118 2.30393 3.28314 1.97794L2.55407 0.788207ZM9.08521 17.5254C8.89637 17.2064 8.73061 16.9248 8.5694 16.7036C8.39954 16.4706 8.20484 16.2609 7.93475 16.1038L7.23323 17.31C7.27733 17.3356 7.33741 17.3824 7.44172 17.5254C7.55462 17.6804 7.68219 17.8945 7.88446 18.2362L9.08521 17.5254ZM6.07131 17.2013C6.47977 17.2083 6.73848 17.2135 6.9357 17.2353C7.11999 17.2558 7.19142 17.2856 7.23323 17.31L7.93475 16.1038C7.66242 15.9453 7.37903 15.8805 7.08927 15.8484C6.81246 15.8178 6.47791 15.8128 6.09535 15.8062L6.07131 17.2013ZM12.1155 18.2362C12.3178 17.8945 12.4453 17.6804 12.5582 17.5254C12.6625 17.3824 12.7226 17.3356 12.7667 17.31L12.0652 16.1038C11.7952 16.2609 11.6004 16.4706 11.4306 16.7036C11.2694 16.9248 11.1036 17.2064 10.9147 17.5254L12.1155 18.2362ZM13.9047 15.8062C13.522 15.8128 13.1875 15.8178 12.9107 15.8484C12.6209 15.8805 12.3376 15.9453 12.0652 16.1038L12.7667 17.31C12.8086 17.2856 12.88 17.2558 13.0643 17.2353C13.2615 17.2135 13.5202 17.2083 13.9287 17.2013L13.9047 15.8062Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M6.2793 7.20947H13.7212"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M6.2793 10.4653H11.3956"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "friend") {
    return (
      <svg
        className={classname}
        style={style}
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 22.4499L20.2783 16.3774C20.0562 14.5083 18.4563 13.0999 16.5556 13.0999H7.66667C4.33333 13.0999 2.18574 10.0955 1.42441 7.08056L1 5.3999"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M7.66602 13.1001V18.6001C7.66602 20.6743 7.66602 21.7113 8.31689 22.3557C8.96776 23.0001 10.0153 23.0001 12.1105 23.0001C14.2056 23.0001 15.2531 23.0001 15.904 22.3557C16.5549 21.7113 16.5549 20.6743 16.5549 18.6001V13.1001"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.9"
          d="M12.1105 9.8C14.5651 9.8 16.5549 7.83005 16.5549 5.4C16.5549 2.96995 14.5651 1 12.1105 1C9.65586 1 7.66602 2.96995 7.66602 5.4C7.66602 7.83005 9.65586 9.8 12.1105 9.8Z"
          stroke="white"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "message") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6113 19.0881L12.1155 18.2362L10.9147 17.5254L10.4104 18.3774L11.6113 19.0881ZM7.88446 18.2362L8.38874 19.0881L9.58949 18.3774L9.08521 17.5254L7.88446 18.2362ZM10.4104 18.3774C10.2312 18.6803 9.76884 18.6803 9.58949 18.3774L8.38874 19.0881C9.10837 20.304 10.8916 20.304 11.6113 19.0881L10.4104 18.3774ZM8.60465 1.39535H11.3953V1.91679e-07H8.60465V1.39535ZM18.6047 8.60467V9.53491H20V8.60467H18.6047ZM1.39535 9.53491V8.60467H1.91678e-07V9.53491H1.39535ZM1.91678e-07 9.53491C1.91678e-07 10.609 -0.000381234 11.4494 0.0458699 12.1273C0.0925583 12.8115 0.189051 13.3809 0.407154 13.9074L1.69629 13.3734C1.56034 13.0452 1.47982 12.6454 1.43799 12.0323C1.39573 11.413 1.39535 10.628 1.39535 9.53491H1.91678e-07ZM6.09535 15.8062C4.9275 15.786 4.31556 15.7118 3.8359 15.5131L3.30193 16.8022C4.05074 17.1123 4.90361 17.1812 6.07131 17.2013L6.09535 15.8062ZM0.407154 13.9074C0.950028 15.218 1.99131 16.2593 3.30193 16.8022L3.8359 15.5131C2.86718 15.1118 2.09754 14.3422 1.69629 13.3734L0.407154 13.9074ZM18.6047 9.53491C18.6047 10.628 18.6043 11.413 18.562 12.0323C18.5202 12.6454 18.4396 13.0452 18.3037 13.3734L19.5928 13.9074C19.811 13.3809 19.9074 12.8115 19.9541 12.1273C20.0004 11.4494 20 10.609 20 9.53491H18.6047ZM13.9287 17.2013C15.0964 17.1812 15.9493 17.1123 16.698 16.8022L16.1641 15.5131C15.6845 15.7118 15.0725 15.786 13.9047 15.8062L13.9287 17.2013ZM18.3037 13.3734C17.9024 14.3422 17.1328 15.1118 16.1641 15.5131L16.698 16.8022C18.0087 16.2593 19.05 15.218 19.5928 13.9074L18.3037 13.3734ZM11.3953 1.39535C12.9313 1.39535 14.0344 1.39609 14.8948 1.47789C15.7448 1.55871 16.2857 1.71371 16.7168 1.97794L17.446 0.788207C16.7586 0.367043 15.979 0.17934 15.0269 0.0888097C14.0851 -0.000734733 12.9044 1.91679e-07 11.3953 1.91679e-07V1.39535ZM20 8.60467C20 7.09565 20.0007 5.9149 19.9112 4.97314C19.8207 4.021 19.6329 3.24136 19.2118 2.55408L18.022 3.28315C18.2863 3.71434 18.4413 4.25521 18.5221 5.10521C18.6039 5.9656 18.6047 7.06863 18.6047 8.60467H20ZM16.7168 1.97794C17.2488 2.30393 17.6961 2.75119 18.022 3.28315L19.2118 2.55408C18.7708 1.83437 18.1657 1.22925 17.446 0.788207L16.7168 1.97794ZM8.60465 1.91679e-07C7.09564 1.91679e-07 5.91488 -0.000734733 4.97313 0.0888097C4.02099 0.17934 3.24135 0.367043 2.55407 0.788207L3.28314 1.97794C3.71434 1.71371 4.2552 1.55871 5.1052 1.47789C5.96558 1.39609 7.06861 1.39535 8.60465 1.39535V1.91679e-07ZM1.39535 8.60467C1.39535 7.06863 1.39608 5.9656 1.47789 5.10521C1.55871 4.25521 1.7137 3.71434 1.97794 3.28315L0.788205 2.55408C0.367042 3.24136 0.17934 4.021 0.0888095 4.97314C-0.000734731 5.9149 1.91678e-07 7.09565 1.91678e-07 8.60467H1.39535ZM2.55407 0.788207C1.83436 1.22925 1.22925 1.83437 0.788205 2.55408L1.97794 3.28315C2.30393 2.75119 2.75118 2.30393 3.28314 1.97794L2.55407 0.788207ZM9.08521 17.5254C8.89637 17.2064 8.7306 16.9248 8.5694 16.7036C8.39954 16.4706 8.20484 16.2609 7.93475 16.1038L7.23323 17.31C7.27733 17.3356 7.33741 17.3824 7.44172 17.5254C7.55462 17.6804 7.68219 17.8945 7.88446 18.2362L9.08521 17.5254ZM6.07131 17.2013C6.47977 17.2083 6.73848 17.2135 6.9357 17.2353C7.11999 17.2558 7.19142 17.2856 7.23323 17.31L7.93475 16.1038C7.66242 15.9453 7.37903 15.8805 7.08927 15.8484C6.81246 15.8178 6.47791 15.8128 6.09535 15.8062L6.07131 17.2013ZM12.1155 18.2362C12.3178 17.8945 12.4453 17.6804 12.5582 17.5254C12.6625 17.3824 12.7226 17.3356 12.7667 17.31L12.0652 16.1038C11.7952 16.2609 11.6004 16.4706 11.4306 16.7036C11.2694 16.9248 11.1036 17.2064 10.9147 17.5254L12.1155 18.2362ZM13.9047 15.8062C13.522 15.8128 13.1875 15.8178 12.9107 15.8484C12.6209 15.8805 12.3376 15.9453 12.0652 16.1038L12.7667 17.31C12.8086 17.2856 12.88 17.2558 13.0643 17.2353C13.2615 17.2135 13.5202 17.2083 13.9287 17.2013L13.9047 15.8062Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M6.27905 7.20923H13.7209"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M6.27905 10.4651H11.3953"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "hyperlink") {
    return (
      <svg
        className={classname}
        style={style}
        width="22"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99988 7H13.9999"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M8.00001 13H7.00001C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7.00001 1H8.00001"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M14 1H15C18.3137 1 21 3.68629 21 7C21 10.3137 18.3137 13 15 13H14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "tick") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M6.5 10.5L8.5 12.5L13.5 7.5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "stall") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M13 10H7"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "star") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
          stroke="none"
        />
        <path
          d="M10 6.5C10.7241 6.5 11.2064 6.502 11.5654 6.56055C11.8984 6.61485 12.0568 6.70754 12.1748 6.85059C12.3043 7.0077 12.3978 7.24205 12.4482 7.69727C12.4994 8.15867 12.5 8.76942 12.5 9.63867V11.6367C12.5 12.2658 12.4998 12.7037 12.4717 13.0195C12.4578 13.175 12.4389 13.2794 12.418 13.3496C12.3975 13.4182 12.3812 13.4336 12.3848 13.4297C12.3488 13.4695 12.3132 13.4859 12.2861 13.4941C12.2598 13.4816 12.196 13.4464 12.082 13.3496C11.8751 13.1738 11.6098 12.8926 11.2168 12.4756C11.0537 12.3025 10.907 12.1467 10.7754 12.0312C10.6399 11.9123 10.4757 11.7954 10.2637 11.7441C10.0899 11.7022 9.91009 11.7022 9.73633 11.7441C9.52428 11.7954 9.36012 11.9123 9.22461 12.0312C9.09303 12.1467 8.94629 12.3025 8.7832 12.4756C8.39027 12.8927 8.12485 13.1738 7.91797 13.3496C7.80285 13.4474 7.7387 13.4819 7.71289 13.4941C7.68596 13.4857 7.65084 13.4691 7.61523 13.4297C7.6188 13.4336 7.60247 13.4182 7.58203 13.3496C7.56112 13.2794 7.54217 13.175 7.52832 13.0195C7.50019 12.7036 7.5 12.2658 7.5 11.6367V9.63867C7.5 8.76942 7.50062 8.15867 7.55176 7.69727C7.60224 7.24205 7.69567 7.0077 7.8252 6.85059C7.94322 6.70754 8.10163 6.61485 8.43457 6.56055C8.79357 6.502 9.27586 6.5 10 6.5Z"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "danger") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M10 5V11"
          fill="none"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M10 14V14.0001"
          fill="none"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "failed") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M12.5 7.50002L7.50002 12.5M7.5 7.5L12.5 12.5"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "info") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13.5 19.75V12.25" stroke-width="2" stroke-linecap="round" />
        <path
          opacity="0.5"
          d="M1 13.5C1 7.60744 1 4.66116 2.83059 2.83059C4.66116 1 7.60744 1 13.5 1C19.3925 1 22.3389 1 24.1694 2.83059C26 4.66116 26 7.60744 26 13.5C26 19.3925 26 22.3389 24.1694 24.1694C22.3389 26 19.3925 26 13.5 26C7.60744 26 4.66116 26 2.83059 24.1694C1 22.3389 1 19.3925 1 13.5Z"
          stroke-width="2"
        />
        <path d="M13.5 8.2501V8.25" stroke-width="2.5" stroke-linecap="round" />
      </svg>
    );
  }
  if (name === "mission") {
    return (
      <svg
        className={classname}
        width="24"
        height="27"
        viewBox="0 0 24 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M16.8889 3.50244C19.5472 3.51758 20.9869 3.63814 21.926 4.59861C23 5.69694 23 7.4647 23 11.0002V18.5001C23 22.0356 23 23.8034 21.926 24.9017C20.8521 26 19.1236 26 15.6667 26H8.33333C4.87636 26 3.14788 26 2.07394 24.9017C1 23.8034 1 22.0356 1 18.5001V11.0002C1 7.4647 1 5.69694 2.07394 4.59861C3.01307 3.63814 4.45274 3.51758 7.11111 3.50244"
          stroke-width="2"
        />
        <path
          d="M7.11108 15.9998H16.8889"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M5.88892 11.625H18.1111"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M8.33331 20.3748H15.6666"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M7.11108 2.87498C7.11108 1.83945 7.93189 1 8.94442 1H15.0555C16.068 1 16.8889 1.83945 16.8889 2.87498V4.12497C16.8889 5.1605 16.068 5.99995 15.0555 5.99995H8.94442C7.93189 5.99995 7.11108 5.1605 7.11108 4.12497V2.87498Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "stats") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          stroke-width="2"
        />
        <path d="M6 17V8" stroke-width="2" stroke-linecap="round" />
        <path d="M11 17V5" stroke-width="2" stroke-linecap="round" />
        <path d="M16 17V12" stroke-width="2" stroke-linecap="round" />
      </svg>
    );
  }
  if (name === "balance") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M2 11C2 14.7712 2 18.6569 3.31802 19.8284C4.63604 21 6.75736 21 11 21C15.2426 21 17.364 21 18.682 19.8284C20 18.6569 20 14.7712 20 11"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M13.6603 13.2019L19.6676 11.3997C20.2631 11.2211 20.5609 11.1317 20.7498 10.9176C20.7866 10.8759 20.8199 10.8312 20.8492 10.784C21 10.5415 21 10.2307 21 9.6089C21 7.15877 21 5.9337 20.327 5.10659C20.1977 4.94763 20.0524 4.80233 19.8934 4.67298C19.0663 4 17.8412 4 15.3911 4H6.60893C4.15877 4 2.9337 4 2.10659 4.67298C1.94763 4.80233 1.80233 4.94763 1.67298 5.10659C1 5.9337 1 7.15877 1 9.6089C1 10.2307 1 10.5415 1.15078 10.784C1.18015 10.8312 1.21341 10.8759 1.25021 10.9176C1.43915 11.1317 1.7369 11.2211 2.3324 11.3997L8.33968 13.2019"
          stroke="white"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M5.5 4C6.32344 3.97913 7.15925 3.45491 7.43944 2.68032C7.44806 2.65649 7.4569 2.62999 7.47457 2.57697L7.50023 2.5C7.54241 2.37344 7.56351 2.31014 7.58608 2.254C7.87427 1.53712 8.54961 1.05037 9.3208 1.00366C9.3812 1 9.4479 1 9.5814 1H12.4191C12.5525 1 12.6192 1 12.6796 1.00366C13.4508 1.05037 14.1262 1.53712 14.4144 2.254C14.4369 2.31014 14.458 2.37343 14.5002 2.5L14.5259 2.57697C14.5435 2.62968 14.5524 2.65656 14.561 2.68032C14.8412 3.45491 15.6766 3.97913 16.5 4"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M13 11.5H9C8.72386 11.5 8.5 11.7239 8.5 12V14.1615C8.5 14.3659 8.62448 14.5498 8.8143 14.6257L9.5144 14.9058C10.4681 15.2872 11.5319 15.2872 12.4856 14.9058L13.1857 14.6257C13.3755 14.5498 13.5 14.3659 13.5 14.1615V12C13.5 11.7239 13.2761 11.5 13 11.5Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "pnl") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M6 13L8.29289 10.7071C8.68342 10.3166 9.3166 10.3166 9.7071 10.7071L11.2929 12.2929C11.6834 12.6834 12.3166 12.6834 12.7071 12.2929L16 9M16 9V11.5M16 9H13.5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "pnlloss") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M6 9L8.29289 11.2929C8.68342 11.6834 9.3166 11.6834 9.7071 11.2929L11.2929 9.7071C11.6834 9.3166 12.3166 9.3166 12.7071 9.7071L16 13M16 13V10.5M16 13H13.5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "days") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66663 20.6667H14.6666"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M3.66663 17.6667H17.6666"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.666626 14.6667H20.6666"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M10.6666 4.66675C7.35292 4.66675 4.66663 7.35304 4.66663 10.6667C4.66663 12.1884 5.23308 13.5777 6.16663 14.6354H15.1666C16.1001 13.5777 16.6666 12.1884 16.6666 10.6667C16.6666 7.35304 13.9803 4.66675 10.6666 4.66675Z"
          stroke="white"
          stroke-width="1.33333"
        />
        <path
          d="M10.9723 10.6619V14.2224H10.361V10.6619L10.6666 10.3562L10.9723 10.6619ZM9.47229 10.2927L9.1969 10.5681L8.76526 10.1365L9.47229 9.42944V10.2927ZM12.568 10.1365L12.1364 10.5681L11.861 10.2927V9.42944L12.568 10.1365Z"
          stroke="white"
          stroke-width="0.888889"
        />
        <path
          opacity="0.5"
          d="M10.6666 0.666748V1.66675"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M20.6666 10.6667H19.6666"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M1.66663 10.6667H0.666626"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M17.7374 3.59644L17.3446 3.98927"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M3.98842 3.98903L3.59558 3.59619"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "clock") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 8.19995V13L16 16"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M1 13C1 7.34314 1 4.51472 2.75736 2.75736C4.51472 1 7.34314 1 13 1C18.6568 1 21.4853 1 23.2426 2.75736C25 4.51472 25 7.34314 25 13C25 18.6568 25 21.4853 23.2426 23.2426C21.4853 25 18.6568 25 13 25C7.34314 25 4.51472 25 2.75736 23.2426C1 21.4853 1 18.6568 1 13Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "stats2") {
    return (
      <svg
        className={classname}
        width="25"
        height="27"
        viewBox="0 0 25 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 26H24"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 12.25C1 11.0715 1 10.4822 1.37425 10.1161C1.74851 9.75 2.35085 9.75 3.55555 9.75C4.76026 9.75 5.3626 9.75 5.73686 10.1161C6.11111 10.4822 6.11111 11.0715 6.11111 12.25V19.75C6.11111 20.9285 6.11111 21.5178 5.73686 21.8839C5.3626 22.25 4.76026 22.25 3.55555 22.25C2.35085 22.25 1.74851 22.25 1.37425 21.8839C1 21.5178 1 20.9285 1 19.75V12.25Z"
          stroke-width="1.5"
        />
        <path
          d="M9.94446 7.25C9.94446 6.07149 9.94446 5.48224 10.3187 5.11611C10.693 4.75 11.2953 4.75 12.5 4.75C13.7047 4.75 14.307 4.75 14.6813 5.11611C15.0556 5.48224 15.0556 6.07149 15.0556 7.25V19.75C15.0556 20.9285 15.0556 21.5178 14.6813 21.8839C14.307 22.25 13.7047 22.25 12.5 22.25C11.2953 22.25 10.693 22.25 10.3187 21.8839C9.94446 21.5178 9.94446 20.9285 9.94446 19.75V7.25Z"
          stroke-width="1.5"
        />
        <path
          d="M18.8889 3.5C18.8889 2.32149 18.8889 1.73224 19.2632 1.36611C19.6374 1 20.2398 1 21.4445 1C22.6492 1 23.2515 1 23.6258 1.36611C24 1.73224 24 2.32149 24 3.5V19.75C24 20.9285 24 21.5178 23.6258 21.8839C23.2515 22.25 22.6492 22.25 21.4445 22.25C20.2398 22.25 19.6374 22.25 19.2632 21.8839C18.8889 21.5178 18.8889 20.9285 18.8889 19.75V3.5Z"
          stroke-width="1.5"
        />
      </svg>
    );
  }
  if (name === "archive") {
    return (
      <svg
        className={classname}
        width="27"
        height="25"
        viewBox="0 0 27 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.75 12.4999C9.75 11.9046 9.75 11.6069 9.84515 11.372C9.97201 11.059 10.2154 10.8102 10.5217 10.6805C10.7514 10.5833 11.0426 10.5833 11.625 10.5833H15.375C15.9574 10.5833 16.2486 10.5833 16.4784 10.6805C16.7846 10.8102 17.028 11.059 17.1549 11.372C17.25 11.6069 17.25 11.9046 17.25 12.4999C17.25 13.0952 17.25 13.393 17.1549 13.6278C17.028 13.9409 16.7846 14.1897 16.4784 14.3193C16.2486 14.4166 15.9574 14.4166 15.375 14.4166H11.625C11.0426 14.4166 10.7514 14.4166 10.5217 14.3193C10.2154 14.1897 9.97201 13.9409 9.84515 13.6278C9.75 13.393 9.75 13.0952 9.75 12.4999Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M24.125 6.11108V13.7777C24.125 18.5965 24.125 21.006 22.6605 22.5029C21.1961 24 18.839 24 14.125 24H12.875C8.16095 24 5.80394 24 4.33946 22.5029C2.875 21.006 2.875 18.5965 2.875 13.7777V6.11108"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M1 3.55555C1 2.35085 1 1.74851 1.36611 1.37425C1.73224 1 2.32149 1 3.5 1H23.5C24.6785 1 25.2677 1 25.6339 1.37425C26 1.74851 26 2.35085 26 3.55555C26 4.76026 26 5.3626 25.6339 5.73686C25.2677 6.11111 24.6785 6.11111 23.5 6.11111H3.5C2.32149 6.11111 1.73224 6.11111 1.36611 5.73686C1 5.3626 1 4.76026 1 3.55555Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "lock") {
    return (
      <svg
        className={classname}
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 26.1999C1 21.1088 1 18.5632 2.58162 16.9816C4.16325 15.3999 6.70883 15.3999 11.8 15.3999H26.2C31.2911 15.3999 33.8367 15.3999 35.4183 16.9816C37 18.5632 37 21.1088 37 26.1999C37 31.291 37 33.8366 35.4183 35.4182C33.8367 36.9999 31.2911 36.9999 26.2 36.9999H11.8C6.70883 36.9999 4.16325 36.9999 2.58162 35.4182C1 33.8366 1 31.291 1 26.1999Z"
          stroke-width="2"
        />
        <path
          d="M19.0001 22.6001V29.8001"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M8.20007 15.4V11.8C8.20007 5.83532 13.0354 1 19.0001 1C24.9647 1 29.8001 5.83532 29.8001 11.8V15.4"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "deposit") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M8.6665 16.6665C13.0848 16.6665 16.6665 13.0848 16.6665 8.6665C16.6665 4.24823 13.0848 0.666504 8.6665 0.666504C4.24823 0.666504 0.666504 4.24823 0.666504 8.6665C0.666504 13.0848 4.24823 16.6665 8.6665 16.6665Z"
          stroke="#15A946"
          stroke-width="1.33333"
        />
        <path
          d="M6.2666 11.0666L11.0666 6.2666M11.0666 6.2666H7.4666M11.0666 6.2666V9.8666"
          stroke="#15A946"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "withdraw") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M8.6665 0.666504C4.24823 0.666504 0.666504 4.24823 0.666504 8.6665C0.666504 13.0848 4.24823 16.6665 8.6665 16.6665C13.0848 16.6665 16.6665 13.0848 16.6665 8.6665C16.6665 4.24823 13.0848 0.666504 8.6665 0.666504Z"
          stroke="#D71F1F"
          stroke-width="1.33333"
        />
        <path
          d="M11.0664 6.26641L6.26641 11.0664M6.26641 11.0664H9.86641M6.26641 11.0664V7.46641"
          stroke="#D71F1F"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "select") {
    return (
      <svg
        className={classname}
        width="12"
        height="6"
        viewBox="0 0 12 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L6 5L11 1"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "payout") {
    return (
      <svg
        className={classname}
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M13.8334 7.08824C15.341 6.85872 16.5 5.47881 16.5 3.81088C16.5 1.98234 15.1071 0.5 13.3889 0.5H3.61111C1.8929 0.5 0.5 1.98234 0.5 3.81088C0.5 5.47881 1.65898 6.85872 3.16666 7.08824"
          stroke="white"
        />
        <path
          d="M8.50002 2.9707V8.73541M8.50002 8.73541L10.1 6.81387M8.50002 8.73541L6.90002 6.81387"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.90002 6.26482C2.90002 4.71196 2.90002 3.93553 3.36866 3.45312C3.83728 2.9707 4.59153 2.9707 6.10002 2.9707H10.9C12.4085 2.9707 13.1627 2.9707 13.6314 3.45312C14.1 3.93553 14.1 4.71196 14.1 6.26482V11.206C14.1 12.7588 14.1 13.5353 13.6314 14.0177C13.1627 14.5001 12.4085 14.5001 10.9 14.5001H6.10002C4.59153 14.5001 3.83728 14.5001 3.36866 14.0177C2.90002 13.5353 2.90002 12.7588 2.90002 11.206V6.26482Z"
          stroke="white"
        />
        <path
          opacity="0.5"
          d="M2.90002 12.0293H14.1"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "edit") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M12.7216 2.16406C12.7216 2.16406 12.7864 3.26705 13.7597 4.24027C14.7329 5.21349 15.8359 5.27837 15.8359 5.27837M7.47996 11.8701L6.12988 10.52"
          stroke-width="2"
        />
        <path
          d="M12.7214 2.16405L13.2405 1.64499C14.1005 0.785002 15.4948 0.785002 16.3548 1.64499C17.2148 2.50499 17.2148 3.89932 16.3548 4.75931L15.8357 5.27836L11.0639 10.0502C10.7407 10.3734 10.5791 10.535 10.4008 10.6741C10.1907 10.838 9.96325 10.9786 9.72261 11.0933C9.51861 11.1905 9.30181 11.2627 8.86813 11.4073L7.47981 11.8701L6.58148 12.1695C6.36809 12.2406 6.13281 12.1851 5.97376 12.0261C5.8147 11.867 5.75917 11.6318 5.83029 11.4183L6.12974 10.52L6.59252 9.13168C6.73706 8.698 6.80933 8.4812 6.90656 8.2772C7.02124 8.03656 7.1618 7.80912 7.32575 7.59896C7.46477 7.42072 7.62637 7.25915 7.94957 6.93595L12.7214 2.16405Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M17 9C17 13.4182 13.4182 17 9 17C4.58172 17 1 13.4182 1 9C1 4.58172 4.58172 1 9 1"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "check") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
          stroke-width="2"
        />
        <path
          d="M6.20001 9.4L7.80001 11L11.8 7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "close") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
          stroke-width="2"
        />
        <path
          d="M11 7.00002L6.99995 11M6.99994 7L11 11"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "profilePicture") {
    return (
      <svg
        className={classname}
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="99" height="99" rx="49.5" />
        <path
          d="M50.0002 49.8C56.9038 49.8 62.5002 44.2483 62.5002 37.4C62.5002 30.5517 56.9038 25 50.0002 25C43.0967 25 37.5002 30.5517 37.5002 37.4C37.5002 44.2483 43.0967 49.8 50.0002 49.8Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M75 73.0501C75 80.7545 75 87.0001 50 87.0001C25 87.0001 25 80.7545 25 73.0501C25 65.3457 36.1929 59.1001 50 59.1001C63.8072 59.1001 75 65.3457 75 73.0501Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "upload") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M1 11.5001L2.75159 9.96748C3.66286 9.17018 5.03628 9.21588 5.89249 10.0721L10.1822 14.3618C10.8694 15.0491 11.9512 15.1428 12.7464 14.5839L13.0446 14.3744C14.1888 13.5702 15.7369 13.6634 16.7765 14.599L20 17.5001"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M16 1V10M16 1L19 4M16 1L13 4"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "plus") {
    return (
      <svg
        className={classname}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 10C1 5.75736 1 3.63604 2.31802 2.31802C3.63604 1 5.75736 1 10 1C14.2426 1 16.364 1 17.6819 2.31802C19 3.63604 19 5.75736 19 10C19 14.2426 19 16.364 17.6819 17.6819C16.364 19 14.2426 19 10 19C5.75736 19 3.63604 19 2.31802 17.6819C1 16.364 1 14.2426 1 10Z"
          stroke-width="2"
        />
        <path
          d="M12.7 10H9.99999M9.99999 10H7.29999M9.99999 10V7.30005M9.99999 10V12.7"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "minus") {
    return (
      <svg
        className={classname}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 10C1 5.75736 1 3.63604 2.31802 2.31802C3.63604 1 5.75736 1 10 1C14.2426 1 16.364 1 17.6819 2.31802C19 3.63604 19 5.75736 19 10C19 14.2426 19 16.364 17.6819 17.6819C16.364 19 14.2426 19 10 19C5.75736 19 3.63604 19 2.31802 17.6819C1 16.364 1 14.2426 1 10Z"
          stroke-width="2"
        />
        <path d="M12.7 10H7.30005" stroke-width="2" stroke-linecap="round" />
      </svg>
    );
  }
  if (name === "line") {
    return (
      <svg
        className={classname}
        viewBox="0 0 101 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.500061 15.5C0.500061 15.5 22.8858 0.5 50.5001 0.5C78.1143 0.5 100.5 15.5 100.5 15.5"
          stroke="url(#paint0_linear_962_66)"
          stroke-linecap="round"
          stroke-dasharray="2 2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_962_66"
            x1="0.500061"
            y1="8"
            x2="100.5"
            y2="8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2878A3" />
            <stop offset="1" stop-color="#2878A3" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === "lineMirrored") {
    return (
      <svg
        className={classname}
        viewBox="0 0 101 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.500061 0.5C0.500061 0.5 22.8858 15.5 50.5001 15.5C78.1143 15.5 100.5 0.5 100.5 0.5"
          stroke="url(#paint0_linear_962_66)"
          stroke-linecap="round"
          stroke-dasharray="2 2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_962_66"
            x1="0.500061"
            y1="8"
            x2="100.5"
            y2="8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2878A3" />
            <stop offset="1" stop-color="#2878A3" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === "inviteMail") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 25C6.37264 25 0.999999 19.6274 0.999999 13C0.999999 6.37258 6.37264 1 13 1C19.6274 1 25 6.37258 25 13C25 14.9196 24.5493 16.7339 23.7478 18.343C23.5349 18.7706 23.464 19.2593 23.5875 19.7207L24.3022 22.392C24.6125 23.5516 23.5516 24.6124 22.392 24.3022L19.7207 23.5875C19.2593 23.464 18.7705 23.5349 18.343 23.7478C16.734 24.5493 14.9196 25 13 25Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M13 10.0009L13.6431 10.6306C13.4737 10.8035 13.242 10.9009 13 10.9009C12.7579 10.9009 12.5262 10.8035 12.3569 10.6306L13 10.0009ZM14.7826 15.8458C15.4805 15.252 16.1811 14.5643 16.7004 13.8532C17.2303 13.1274 17.5 12.4745 17.5 11.9313H19.3C19.3 13.0301 18.7784 14.0596 18.1541 14.9147C17.5192 15.7842 16.7026 16.5755 15.9489 17.2168L14.7826 15.8458ZM17.5 11.9313C17.5 10.602 16.9065 9.90202 16.296 9.67372C15.6754 9.44166 14.6859 9.56553 13.6431 10.6306L12.3569 9.37128C13.744 7.95464 15.4545 7.43736 16.9264 7.98773C18.4084 8.54188 19.3 10.0479 19.3 11.9313H17.5ZM10.0511 17.2168C9.29739 16.5755 8.48079 15.7842 7.84587 14.9147C7.22151 14.0596 6.69999 13.0301 6.69999 11.9313H8.49999C8.49999 12.4745 8.76975 13.1275 9.29955 13.8532C9.81891 14.5644 10.5195 15.252 11.2174 15.8458L10.0511 17.2168ZM6.69999 11.9313C6.69999 10.0479 7.59159 8.54187 9.07359 7.98773C10.5455 7.43736 12.256 7.95464 13.6431 9.37128L12.3569 10.6306C11.3141 9.56553 10.3246 9.44166 9.70395 9.67372C9.09339 9.90202 8.49999 10.602 8.49999 11.9313H6.69999ZM15.9489 17.2168C15.0135 18.0125 14.2686 18.6928 13 18.6928V16.8928C13.4968 16.8928 13.7406 16.7321 14.7826 15.8458L15.9489 17.2168ZM11.2174 15.8458C12.2593 16.7321 12.5032 16.8928 13 16.8928V18.6928C11.7313 18.6928 10.9865 18.0125 10.0511 17.2168L11.2174 15.8458Z"
          fill="white"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "signUp") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M13 25C6.37257 25 1.00003 19.6275 1.00003 13C1.00003 6.37258 6.37257 1 13 1"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M25 13H10M10 13L14.5 8.5M10 13L14.5 17.5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "gift") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M24.6667 12.6667H0.666687"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M12.6666 0.666748V24.6667"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          d="M13.8666 12.6667C13.8666 15.3177 16.0157 17.4667 18.6666 17.4667"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          d="M11.4669 12.6667C11.4669 15.3177 9.3179 17.4667 6.66693 17.4667"
          stroke-width="1.33333"
          stroke-linecap="round"
        />
        <path
          d="M12.6666 10.309C12.6666 8.52115 13.8834 6.96271 15.6179 6.52909C17.5423 6.04797 19.2856 7.79117 18.8044 9.71564C18.3708 11.4501 16.8124 12.6669 15.0245 12.6669H12.6666V10.309Z"
          stroke-width="1.33333"
        />
        <path
          d="M12.667 10.309C12.667 8.52115 11.4502 6.96271 9.71576 6.52909C7.7913 6.04797 6.0481 7.79117 6.52921 9.71564C6.96283 11.4501 8.52127 12.6669 10.3092 12.6669H12.667V10.309Z"
          stroke-width="1.33333"
        />
        <path
          d="M0.666687 12.6667C0.666687 7.00989 0.666687 4.18146 2.42405 2.42411C4.1814 0.666748 7.00983 0.666748 12.6667 0.666748C18.3235 0.666748 21.152 0.666748 22.9093 2.42411C24.6667 4.18146 24.6667 7.00989 24.6667 12.6667C24.6667 18.3235 24.6667 21.1521 22.9093 22.9093C21.152 24.6667 18.3235 24.6667 12.6667 24.6667C7.00983 24.6667 4.1814 24.6667 2.42405 22.9093C0.666687 21.1521 0.666687 18.3235 0.666687 12.6667Z"
          stroke-width="1.33333"
        />
      </svg>
    );
  }
  if (name === "sale") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M10.1109 2.44033C10.8452 1.81459 11.2122 1.50173 11.5961 1.31827C12.4839 0.893912 13.516 0.893912 14.4039 1.31827C14.7878 1.50173 15.1548 1.81459 15.8891 2.44033C16.1813 2.68937 16.3275 2.81389 16.4836 2.91848C16.8413 3.15825 17.243 3.32466 17.6654 3.40806C17.8498 3.44446 18.0411 3.45973 18.424 3.49027C19.3856 3.56701 19.8664 3.60538 20.2676 3.74707C21.1954 4.07481 21.9252 4.80461 22.253 5.73245C22.3947 6.13361 22.433 6.61444 22.5098 7.5761C22.5403 7.95885 22.5555 8.15022 22.592 8.33453C22.6753 8.75702 22.8417 9.15875 23.0816 9.51649C23.1861 9.67254 23.3106 9.81866 23.5597 10.1109C24.1854 10.8451 24.4984 11.2124 24.6818 11.5961C25.1061 12.4839 25.1061 13.516 24.6818 14.4039C24.4984 14.7877 24.1854 15.1548 23.5597 15.8891C23.3106 16.1813 23.1861 16.3274 23.0816 16.4836C22.8417 16.8413 22.6753 17.243 22.592 17.6656C22.5555 17.8498 22.5403 18.0412 22.5098 18.4239C22.433 19.3856 22.3947 19.8664 22.253 20.2676C21.9252 21.1954 21.1954 21.9252 20.2676 22.253C19.8664 22.3947 19.3856 22.433 18.424 22.5098C18.0411 22.5403 17.8498 22.5556 17.6654 22.5919C17.243 22.6754 16.8413 22.8417 16.4836 23.0816C16.3275 23.1861 16.1813 23.3106 15.8891 23.5597C15.1548 24.1854 14.7878 24.4983 14.4039 24.6818C13.516 25.1061 12.4839 25.1061 11.5961 24.6818C11.2122 24.4983 10.8452 24.1854 10.1109 23.5597C9.81866 23.3106 9.67253 23.1861 9.51648 23.0816C9.15876 22.8417 8.75702 22.6754 8.33453 22.5919C8.15022 22.5556 7.95885 22.5403 7.5761 22.5098C6.61444 22.433 6.1336 22.3947 5.73245 22.253C4.80461 21.9252 4.0748 21.1954 3.74708 20.2676C3.60539 19.8664 3.56701 19.3856 3.49027 18.4239C3.45973 18.0412 3.44446 17.8498 3.40807 17.6656C3.32466 17.243 3.15826 16.8413 2.91849 16.4836C2.8139 16.3274 2.68937 16.1813 2.44033 15.8891C1.81459 15.1548 1.50173 14.7877 1.31826 14.4039C0.893915 13.516 0.893915 12.4839 1.31826 11.5961C1.50173 11.2122 1.81459 10.8451 2.44033 10.1109C2.68937 9.81866 2.8139 9.67254 2.91849 9.51649C3.15826 9.15875 3.32466 8.75702 3.40807 8.33453C3.44446 8.15022 3.45973 7.95885 3.49027 7.5761C3.56701 6.61444 3.60539 6.13361 3.74708 5.73245C4.0748 4.80461 4.80461 4.07481 5.73245 3.74707C6.1336 3.60538 6.61444 3.56701 7.5761 3.49027C7.95885 3.45973 8.15022 3.44446 8.33453 3.40806C8.75702 3.32466 9.15876 3.15825 9.51648 2.91848C9.67254 2.81389 9.81866 2.68937 10.1109 2.44033Z"
          fill="none"
          stroke-width="2"
        />
        <path
          d="M9.09344 16.9073L16.9065 9.09424"
          fill="none"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M17.5576 16.256C17.5576 16.9752 16.9746 17.5582 16.2554 17.5582C15.5362 17.5582 14.9532 16.9752 14.9532 16.256C14.9532 15.5368 15.5362 14.9539 16.2554 14.9539C16.9746 14.9539 17.5576 15.5368 17.5576 16.256Z"
          stroke="none"
        />
        <path
          d="M11.0467 9.74529C11.0467 10.4645 10.4638 11.0475 9.74456 11.0475C9.02539 11.0475 8.44238 10.4645 8.44238 9.74529C8.44238 9.02613 9.02539 8.44312 9.74456 8.44312C10.4638 8.44312 11.0467 9.02613 11.0467 9.74529Z"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "cart") {
    return (
      <svg
        className={classname}
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M7.31724 18.4392C8.2871 18.4392 9.07332 19.2255 9.07332 20.1953C9.07332 21.1651 8.2871 21.9514 7.31724 21.9514C6.34738 21.9514 5.56116 21.1651 5.56116 20.1953C5.56116 19.2255 6.34738 18.4392 7.31724 18.4392Z"
          stroke="white"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M17.8537 18.4392C18.8236 18.4392 19.6098 19.2253 19.6098 20.1953C19.6098 21.1651 18.8236 21.9514 17.8537 21.9514C16.8839 21.9514 16.0977 21.1651 16.0977 20.1953C16.0977 19.2253 16.8839 18.4392 17.8537 18.4392Z"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M1.16951 0.0499449C0.712023 -0.1109 0.210779 0.129577 0.0499449 0.587048C-0.1109 1.04453 0.129577 1.54577 0.587048 1.70661L1.16951 0.0499449ZM22.7214 8.93605L23.5812 9.11336L23.5824 9.10797L22.7214 8.93605ZM5.2194 8.79235V5.60607H3.46332V8.79235H5.2194ZM1.47531 0.157452L1.16951 0.0499449L0.587048 1.70661L0.892852 1.81413L1.47531 0.157452ZM11.3416 16.3903H17.5498V14.6342H11.3416V16.3903ZM5.2194 5.60607C5.2194 4.77818 5.2206 4.08734 5.15982 3.52594C5.09692 2.94482 4.96064 2.41481 4.63052 1.93173L3.18063 2.92251C3.2863 3.07715 3.3679 3.28954 3.41394 3.71492C3.46213 4.16004 3.46332 4.73979 3.46332 5.60607H5.2194ZM0.892852 1.81413C1.67444 2.08892 2.18809 2.27102 2.56606 2.45648C2.92104 2.63066 3.07753 2.77165 3.18063 2.92251L4.63052 1.93173C4.29782 1.44487 3.85547 1.13306 3.33961 0.879951C2.84671 0.638103 2.21752 0.418406 1.47531 0.157452L0.892852 1.81413ZM3.46332 8.79235C3.46332 10.4928 3.47928 11.719 3.63973 12.6558C3.81103 13.656 4.15304 14.3721 4.79252 15.0466L6.06689 13.8384C5.69207 13.443 5.4899 13.0559 5.3706 12.3594C5.24046 11.5995 5.2194 10.5356 5.2194 8.79235H3.46332ZM11.3416 14.6342C9.6829 14.6342 8.53202 14.6321 7.6649 14.5092C6.82805 14.3905 6.38596 14.1749 6.06689 13.8384L4.79252 15.0466C5.48777 15.7799 6.3691 16.0992 7.41834 16.2478C8.43732 16.3924 9.73519 16.3903 11.3416 16.3903V14.6342ZM4.34136 5.40897H18.543V3.65288H4.34136V5.40897ZM21.8613 8.75881L21.2763 11.5975L22.9962 11.952L23.5812 9.11336L21.8613 8.75881ZM18.543 5.40897C19.5457 5.40897 20.428 5.41014 21.1244 5.48798C21.4704 5.52666 21.7294 5.58039 21.9113 5.64434C22.1003 5.71073 22.1304 5.76167 22.1153 5.74191L23.5071 4.67115C23.232 4.31359 22.8452 4.11116 22.4935 3.98756C22.1347 3.86148 21.7289 3.78854 21.3195 3.74277C20.5049 3.65171 19.5131 3.65288 18.543 3.65288V5.40897ZM23.5824 9.10797C23.7805 8.11528 23.9487 7.2824 23.9899 6.61525C24.0322 5.92898 23.9541 5.25229 23.5071 4.67115L22.1153 5.74191C22.1879 5.83637 22.268 6.00647 22.2371 6.50707C22.2051 7.0268 22.0686 7.72088 21.8603 8.76419L23.5824 9.10797ZM17.5498 16.3903C18.4415 16.3903 19.1899 16.3918 19.7931 16.318C20.4203 16.2413 20.9923 16.0735 21.4916 15.6666L20.3822 14.3053C20.2357 14.4247 20.0279 14.5201 19.5798 14.575C19.1078 14.6327 18.4856 14.6342 17.5498 14.6342V16.3903ZM21.2763 11.5975C21.0874 12.514 20.9602 13.1232 20.8084 13.5738C20.6643 14.0015 20.5288 14.1859 20.3822 14.3053L21.4916 15.6666C21.9909 15.2596 22.2707 14.7333 22.4726 14.1346C22.6667 13.5586 22.8162 12.8254 22.9962 11.952L21.2763 11.5975Z"
          fill="white"
          stroke="none"
        />
        <path
          opacity="0.5"
          d="M11.4148 10.0099L12.7528 11.4147L16.0977 7.90259"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "test") {
    return (
      <svg
        className={classname}
        width="26"
        height="24"
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.00006 4L2.45721 5.8L7.60006 1"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M1.00006 12.3999L2.45721 14.1999L7.60006 9.3999"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.00006 20.8L2.45721 22.6L7.60006 17.8"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M25.0001 20.2H13.0001"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M25.0001 11.8H13.0001"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M25.0001 3.3999H13.0001"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "saleForCoupon") {
    return (
      <svg
        className={classname}
        width="34"
        height="30"
        viewBox="0 0 34 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.37402 21.9478C3.37402 19.3442 5.66963 17.1032 8.63672 17.103C11.6007 17.103 13.8972 19.3432 13.8975 21.9468C13.8975 24.5551 11.6006 26.7954 8.63672 26.7954C7.22426 26.7953 5.91031 26.2886 4.92285 25.3843V25.3833C3.91358 24.4606 3.37415 23.2418 3.37402 21.9478Z"
          stroke-width="2"
        />
        <path
          d="M3.25482 7.25L3.2558 7.24902C3.27986 7.2047 3.32839 7.19583 3.36029 7.21387L3.36127 7.21484L30.8554 22.6895L30.8593 22.6914C30.8774 22.7015 30.8939 22.7188 30.9023 22.748C30.9107 22.7777 30.9069 22.8086 30.8915 22.8369C30.8638 22.8859 30.8159 22.8902 30.787 22.874L30.7851 22.8721L3.29095 7.39844L3.28705 7.39648C3.26895 7.38638 3.25338 7.36831 3.24506 7.33887C3.23672 7.3091 3.23941 7.27828 3.25482 7.25Z"
          stroke-width="2"
        />
        <path
          d="M20.3062 8.05249C20.3062 6.75882 20.8445 5.54174 21.855 4.61597C22.8424 3.7118 24.1564 3.2049 25.5689 3.20483C28.5329 3.20487 30.8297 5.44424 30.8297 8.05249C30.8295 10.6602 28.5332 12.8982 25.5689 12.8982C22.6017 12.8981 20.3064 10.6599 20.3062 8.05249Z"
          stroke-width="2"
        />
        <path
          d="M23.9266 8.06909C23.9266 7.62486 24.4571 6.92761 25.5604 6.92749C26.6654 6.92749 27.198 7.62609 27.1981 8.06909C27.1981 8.51065 26.6672 9.20776 25.5604 9.20776C24.4553 9.20764 23.9266 8.51185 23.9266 8.06909Z"
          stroke-width="2"
        />
        <path
          d="M6.92102 22.0674C6.92117 21.6267 7.45081 20.9288 8.55481 20.9287C9.66249 20.9287 10.1914 21.6272 10.1915 22.0674C10.1915 22.5111 9.66175 23.209 8.55481 23.209C7.52026 23.2089 6.989 22.5959 6.92688 22.1533L6.92102 22.0674Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "share") {
    return (
      <svg
        className={classname}
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33338 8.55547C5.33338 9.78276 4.36332 10.7777 3.16669 10.7777C1.97006 10.7777 1 9.78276 1 8.55547C1 7.32819 1.97006 6.33325 3.16669 6.33325C4.36332 6.33325 5.33338 7.32819 5.33338 8.55547Z"
          stroke-width="2"
        />
        <path
          opacity="0.5"
          d="M9.94455 13.2682L5.33331 10.1467"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M10.0314 4.41309L5.42017 7.53456"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M14 14.7779C14 16.0052 13.0299 17.0001 11.8333 17.0001C10.6367 17.0001 9.66663 16.0052 9.66663 14.7779C9.66663 13.5506 10.6367 12.5557 11.8333 12.5557C13.0299 12.5557 14 13.5506 14 14.7779Z"
          stroke-width="2"
        />
        <path
          d="M14 3.22222C14 4.44952 13.0299 5.44444 11.8333 5.44444C10.6367 5.44444 9.66663 4.44952 9.66663 3.22222C9.66663 1.99492 10.6367 1 11.8333 1C13.0299 1 14 1.99492 14 3.22222Z"
          stroke-width="2"
        />
      </svg>
    );
  }
  if (name === "infoCircle") {
    return (
      <svg
        className={classname}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M8.5 16.5C12.9183 16.5 16.5 12.9183 16.5 8.5C16.5 4.08172 12.9183 0.5 8.5 0.5C4.08172 0.5 0.5 4.08172 0.5 8.5C0.5 12.9183 4.08172 16.5 8.5 16.5Z"
          fill="none"
        />
        <path d="M8.49997 12.5V7.69995Z" stroke="none" />
        <path d="M8.49997 12.5V7.69995" fill="none" stroke-linecap="round" />
        <path
          d="M8.50001 4.5001C8.94184 4.5001 9.30001 4.85827 9.30001 5.3001C9.30001 5.74193 8.94184 6.1001 8.50001 6.1001C8.05818 6.1001 7.70001 5.74193 7.70001 5.3001C7.70001 4.85827 8.05818 4.5001 8.50001 4.5001Z"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "download") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11.6667C1 14.1809 1 15.4379 1.78105 16.219C2.5621 17.0001 3.81917 17.0001 6.33333 17.0001H11.6667C14.1808 17.0001 15.4379 17.0001 16.2189 16.219C17 15.4379 17 14.1809 17 11.6667"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.00001 1V12.5556M9.00001 12.5556L12.5556 8.66667M9.00001 12.5556L5.44446 8.66667"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "btc") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#F7931A"
        />
        <path
          d="M11.5946 7.01C11.7516 5.962 10.9531 5.3985 9.86211 5.0225L10.2161 3.6025L9.35211 3.3875L9.00711 4.77C8.78011 4.713 8.54711 4.66 8.31461 4.607L8.66211 3.2155L7.79811 3L7.44411 4.4195C7.25611 4.3765 7.07111 4.3345 6.89211 4.2895L6.89311 4.285L5.70111 3.9875L5.47111 4.9105C5.47111 4.9105 6.11261 5.0575 6.09911 5.0665C6.44911 5.154 6.51211 5.3855 6.50161 5.5695L6.09861 7.187C6.12261 7.193 6.15361 7.202 6.18861 7.2155L6.09711 7.193L5.53211 9.459C5.48911 9.565 5.38061 9.7245 5.13561 9.664C5.14461 9.6765 4.50761 9.5075 4.50761 9.5075L4.07861 10.4965L5.20361 10.777C5.41261 10.8295 5.61761 10.8845 5.81911 10.936L5.46161 12.372L6.32511 12.587L6.67911 11.167C6.91511 11.2305 7.14411 11.2895 7.36811 11.3455L7.01511 12.7595L7.87911 12.9745L8.23661 11.5415C9.71061 11.8205 10.8186 11.708 11.2851 10.375C11.6611 9.302 11.2666 8.6825 10.4911 8.279C11.0561 8.149 11.4811 7.7775 11.5946 7.01ZM9.61961 9.779C9.35311 10.8525 7.54561 10.272 6.95961 10.1265L7.43461 8.224C8.02061 8.3705 9.89911 8.66 9.61961 9.779ZM9.88711 6.9945C9.64361 7.971 8.13961 7.4745 7.65211 7.353L8.08211 5.628C8.56961 5.7495 10.1411 5.976 9.88711 6.9945Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "eth") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#F3BA2F"
        />
        <path
          d="M6.058 7.202L8 5.26L9.943 7.203L11.073 6.073L8 3L4.928 6.072L6.058 7.202ZM3 8L4.13 6.87L5.26 8L4.13 9.13L3 8ZM6.058 8.798L8 10.74L9.943 8.797L11.073 9.9265L8 13L4.928 9.928L4.9265 9.9265L6.058 8.798ZM10.74 8L11.87 6.87L13 8L11.87 9.13L10.74 8ZM9.146 7.999H9.147V8L8 9.147L6.8545 8.002L6.8525 8L6.8545 7.9985L7.055 7.7975L7.1525 7.7L8 6.853L9.1465 7.9995L9.146 7.999Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "sol") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#66F9A1"
        />
        <path
          d="M4.96252 9.8435C5.0178 9.78896 5.09236 9.75842 5.17002 9.7585H12.353C12.382 9.75811 12.4104 9.7664 12.4346 9.7823C12.4588 9.79821 12.4777 9.821 12.4888 9.84774C12.5 9.87447 12.5028 9.90394 12.4971 9.93232C12.4913 9.96071 12.4772 9.98672 12.4565 10.007L11.0375 11.4145C10.9823 11.4692 10.9077 11.5 10.83 11.5H3.64702C3.61806 11.5002 3.58969 11.4918 3.56553 11.4759C3.54138 11.4599 3.52253 11.4371 3.51142 11.4104C3.5003 11.3836 3.49742 11.3542 3.50314 11.3258C3.50886 11.2974 3.52292 11.2714 3.54352 11.251L4.96252 9.8435ZM4.96252 4.585C5.0178 4.53046 5.09236 4.49992 5.17002 4.5H12.353C12.4835 4.5 12.549 4.657 12.4565 4.749L11.0375 6.1565C10.9822 6.21104 10.9077 6.24158 10.83 6.2415H3.64702C3.61816 6.24165 3.58992 6.23321 3.56587 6.21726C3.54182 6.20132 3.52306 6.17858 3.51197 6.15194C3.50087 6.12531 3.49795 6.09598 3.50357 6.06767C3.50918 6.03937 3.52309 6.01338 3.54352 5.993L4.96252 4.585ZM11.0375 7.1975C10.9822 7.14296 10.9077 7.11242 10.83 7.1125H3.64702C3.61806 7.11225 3.58969 7.12065 3.56553 7.13662C3.54138 7.15259 3.52253 7.17541 3.51142 7.20215C3.5003 7.22889 3.49742 7.25834 3.50314 7.28672C3.50886 7.31511 3.52292 7.34115 3.54352 7.3615L4.96252 8.769C5.01752 8.8235 5.09252 8.854 5.17002 8.854H12.353C12.382 8.85425 12.4103 8.84585 12.4345 8.82988C12.4587 8.81391 12.4775 8.79109 12.4886 8.76435C12.4997 8.73761 12.5026 8.70816 12.4969 8.67978C12.4912 8.65139 12.4771 8.62535 12.4565 8.605L11.0375 7.1975Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "add") {
    return (
      <svg
        className={classname}
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 7H7M7 7H1M7 7V1M7 7V13"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "search") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 20C6.2533 20 2 15.7467 2 10.5C2 5.25329 6.2533 1 11.5 1C16.7467 1 21 5.25329 21 10.5C21 15.7467 16.7467 20 11.5 20Z"
          stroke-width="2"
        />
        <path d="M3 19L1 21" stroke-width="2" stroke-linecap="round" />
      </svg>
    );
  }
  if (name === "checkMark") {
    return (
      <svg
        className={classname}
        width="9"
        height="7"
        viewBox="0 0 9 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 4L3 6L8 1"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (name === "xMark") {
    return (
      <svg
        className={classname}
        width="7"
        height="7"
        viewBox="0 0 7 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.00002 1.00002L1.00002 6M1 1L6.00002 6"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (name === "pen") {
    return (
      <svg
        className={classname}
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.91599 1.74723L8.47212 1.1911C9.39358 0.269634 10.8874 0.269634 11.8089 1.1911C12.7304 2.11256 12.7304 3.60642 11.8089 4.52788L11.2528 5.08401M7.91599 1.74723C7.91599 1.74723 7.98559 2.92896 9.02825 3.97175C10.071 5.01441 11.2528 5.08401 11.2528 5.08401M7.91599 1.74723L2.80334 6.86001C2.45694 7.20627 2.28388 7.37934 2.13494 7.57027C1.95935 7.79547 1.80868 8.0392 1.68588 8.29706C1.58161 8.5156 1.50428 8.74787 1.34935 9.21253L0.853483 10.7L0.693085 11.1812M11.2528 5.08401L6.13999 10.1967C5.79373 10.5431 5.62066 10.7161 5.42973 10.8651C5.20453 11.0407 4.9608 11.1913 4.70293 11.3141C4.4844 11.4184 4.25214 11.4957 3.78747 11.6507L2.30001 12.1465L1.81881 12.3069M0.693085 11.1812L0.532685 11.6625C0.456419 11.8911 0.516019 12.1432 0.686418 12.3136C0.856817 12.484 1.10895 12.5436 1.33748 12.4673L1.81881 12.3069M0.693085 11.1812L1.81881 12.3069" />
      </svg>
    );
  }
  if (name === "calendar") {
    return (
      <svg
        className={classname}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 8.10019C0.5 5.08323 0.5 3.57476 1.43726 2.6375C2.37452 1.70026 3.88301 1.70026 6.9 1.70026H10.1C13.117 1.70026 14.6255 1.70026 15.5627 2.6375C16.5 3.57476 16.5 5.08323 16.5 8.10019V9.70018C16.5 12.7171 16.5 14.2257 15.5627 15.1628C14.6255 16.1001 13.117 16.1001 10.1 16.1001H6.9C3.88301 16.1001 2.37452 16.1001 1.43726 15.1628C0.5 14.2257 0.5 12.7171 0.5 9.70018V8.10019Z"
          fill="none"
        />
        <path
          opacity="0.5"
          d="M4.5 1.69999V0.5"
          fill="none"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M12.5 1.69999V0.5"
          fill="none"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M0.900879 5.70001H16.1009"
          fill="none"
          stroke-linecap="round"
        />
        <path
          d="M13.2992 12.0999C13.2992 12.5417 12.9411 12.8999 12.4992 12.8999C12.0574 12.8999 11.6992 12.5417 11.6992 12.0999C11.6992 11.658 12.0574 11.2999 12.4992 11.2999C12.9411 11.2999 13.2992 11.658 13.2992 12.0999Z"
          stroke="none"
        />
        <path
          d="M13.2992 8.90018C13.2992 9.34202 12.9411 9.70017 12.4992 9.70017C12.0574 9.70017 11.6992 9.34202 11.6992 8.90018C11.6992 8.45835 12.0574 8.10019 12.4992 8.10019C12.9411 8.10019 13.2992 8.45835 13.2992 8.90018Z"
          stroke="none"
        />
        <path
          d="M9.29922 12.0999C9.29922 12.5417 8.94106 12.8999 8.49922 12.8999C8.05738 12.8999 7.69922 12.5417 7.69922 12.0999C7.69922 11.658 8.05738 11.2999 8.49922 11.2999C8.94106 11.2999 9.29922 11.658 9.29922 12.0999Z"
          stroke="none"
        />
        <path
          d="M9.29922 8.90018C9.29922 9.34202 8.94106 9.70017 8.49922 9.70017C8.05738 9.70017 7.69922 9.34202 7.69922 8.90018C7.69922 8.45835 8.05738 8.10019 8.49922 8.10019C8.94106 8.10019 9.29922 8.45835 9.29922 8.90018Z"
          stroke="none"
        />
        <path
          d="M5.29922 12.0999C5.29922 12.5417 4.94104 12.8999 4.49922 12.8999C4.05739 12.8999 3.69922 12.5417 3.69922 12.0999C3.69922 11.658 4.05739 11.2999 4.49922 11.2999C4.94104 11.2999 5.29922 11.658 5.29922 12.0999Z"
          stroke="none"
        />
        <path
          d="M5.29922 8.90018C5.29922 9.34202 4.94104 9.70017 4.49922 9.70017C4.05739 9.70017 3.69922 9.34202 3.69922 8.90018C3.69922 8.45835 4.05739 8.10019 4.49922 8.10019C4.94104 8.10019 5.29922 8.45835 5.29922 8.90018Z"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "hamburger") {
    return (
      <svg
        className={classname}
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="138" width="1000" height="100" rx="50" />
        <rect y="450" width="1000" height="100" rx="50" />
        <rect y="762" width="1000" height="100" rx="50" />
      </svg>
    );
  }
  if (name === "hamburgerX") {
    return (
      <svg
        className={classname}
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="181.802"
          y="111.091"
          width="1000"
          height="100"
          rx="50"
          transform="rotate(45 181.802 111.091)"
        />
        <rect
          x="111.091"
          y="818.198"
          width="1000"
          height="100"
          rx="50"
          transform="rotate(-45 111.091 818.198)"
        />
      </svg>
    );
  }
  if (name === "dollar") {
    return (
      <svg className={classname} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.5" cx="12" cy="12" r="10" stroke-width="1.5"/>
        <path d="M12 17V17.5V18" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M12 6V6.5V7" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    );
  }
}
